import {
  ICardiacOptionsState,
  IImagingUltrasoundOptionsState,
  IAddMedicationAdministeredOptionsState,
  IIntubationOptionsState,
  IOptionsState,
  IOptionsStateAction,
  IPatientAllergiesOptionsState,
  IPatientDemographicsOptionsState,
  IPatientMedicalHistoryOptionsState,
  IPatientMedicationsOptionsState,
  ITripInformationOptionsState,
  IVitalOptionsState,
  IPickupAddressOptionsState,
  IAirwayOptionsState,
  IChildbirthOBOptionsState,
  IInitiateIvOptionsState,
  IImmobilizationOptionsState,
  IMedicalConsultOptionsState,
  IOperationsOptionsState,
  IRescueOptionsState,
  IHospitalNotifyOptionsState,
  IWoundCareOptionsState,
  IVentilatorOptionsState,
  ICriticalCareOptionsState,
  ISignatureOptionsState,
  IConfigurationOptionsState,
  ICadImportOptionsState,
  IPhoneDetail,
  IEmailDetail,
  ICcHpiOptionsState,
  IDestinationAddressOptionsState,
  IInsuranceInformationOptionsState,
  IRelationshipsAndGuarantorsOptionsState,
  IPcsInformationOptionsState,
  IAuthorizationInformationOptionState,
  ICmsInformationOptionsState,
  IPaymentInformationOptionState,
  IInsuredOption,
  ICameraAttachmentsOptionsState,
  IFactorsAffectingCareOptionsState,
  IExposureOptionsState,
  ISceneDescriptionOptionsState,
  IInitialAssessmentAirwayOptions,
  IRespiratoryOptionsState,
  INeuroOptionsState,
  IPTSOptionsState,
  IRTSOptionsState,
  IWasPatientImmOptionsState,
  IGCSOptionsState,
  ICardioOptionsState,
  IDrainOptionsState,
  ITitrateOptionsState,
  ILabsOptionsState,
  IPertinentNegativeProcedureOptionsState,
  ISctOptionsState,
  IPnMedicationOptionsState,
  IEmployerOptionsState,
  IImmunizationOptionsState,
  IRulesOptionsState,
  IPulsaraOptionsState,
  IDiagnosisOptionsState,
  IObstetricsOptionsState,
  IBurnOptionsState,
  IBodySurveyOptions,
  IAssessmentProcedureOptionsState,
  IAllPNNVOptionsState,
  INemsisCustomDataOptions,
  IBloodProductAdministrationOptionsState,
  IVentricularAssistTypeOptions,
  IGenericOptions,
  ISpecialReportOptionsState,
  IFillablePDFOptionsState,
} from './options.types'
import { randomNumber } from '../../../utilities'
import { OptionsConstants } from './options.constants'
import { initialVentilatorState } from '../../procedures/ventilator/store/ventilator.reducers'
import { set } from 'lodash'

export const phoneDetailsInit = (): IPhoneDetail => {
  return {
    key: randomNumber().toString(),
    number: '',
    type: null,
  }
}

export const emailDetailsInit = (): IEmailDetail => {
  return {
    key: randomNumber().toString(),
    address: '',
    type: null,
  }
}

export const initialNeuroOptionsState: INeuroOptionsState = {
  motorOptions: [],
  sensoryOptions: [],
  pupilsSizeOptions: [],
  pupilsReactOptions: [],
  headConciousnessOptions: [],
  thromScreenOptions: [],
  strokeScaleNeuroOptions: [],
  headLossConsOptions: [],
  strokeCvaSymptomsResolvedOptions: [],
  strokeScaleScoreOptions: [],
  strokeScaleConfigOptions: [],
  customStrokeScaleScoreOptions: [],
}

export const initialIntubationOptionsState: IIntubationOptionsState = {
  assessedByOptions: [],
  methodOptions: [],
  securedViaOptions: [],
  verifiedByOptions: [],
  mallampatiOptions: [],
  cuffFillOptions: [],
  sellickManeuverOptions: [],
  laryngoscopeBladeOptions: [],
  indicationsOptions: [],
  airwayComplicationsOptions: [],
  procedureComplicationsOptions: [],
  responseOptions: [],
  authorizationOptions: [],
  distanceUnitOptions: [],
  verificationViaOptions: [],
  airwayPlacementTechniqueOptions: [],
  rSIProtocolOptions: [],
  laryngoscopicGradeOptions: [],
  styletUsedOptions: [],
  reasonsForFailureOptions: [],
}

export const initialCardioOptionsState: ICardioOptionsState = {
  pulsesOptions: [],
  prCvAssessOptions: [],
  cvTempMethodOptions: [],
  cvJvdOptions: [],
  cvCapRefillOptions: [],
  cvEdemaOptions: [],
  cvArtOptions: [],
  cvSwanOptions: [],
  pmTypeOptions: [],
}

export const initialPnMedicationOptionsState: IPnMedicationOptionsState = {
  routeOptions: [],
  doseUnitOptions: [],
  medicationOptions: [],
}

export const initialPatientMedicalHistoryOptionsState: IPatientMedicalHistoryOptionsState = {
  medicalHistoryOptions: [],
  medicalHistoryOptionsFullList: [],
  chunkedPatientMedicalHistoryOptions: [],
  transformedChunkedPatientMedicalHistoryOptions: [],
  selectedMedicalHistoryOptions: [],
  medicalHistoryIcdNemsisBasicOptions: [],
  medicalHistoryIcdNemsisBasicOptionsFullList: [],
  obtainedFromOptions: [],
  emergencyInfoFormOptions: [],
}
export const initialVitalOptionsState: IVitalOptionsState = {
  bloodPressureMethodOptions: [],
  heartRateMethodOptions: [],
  ecgTypeOptions: [],
  ecgTypeMethodOptions: [],
  regularityOptions: [],
  rhythmOptions: [],
  temperatureMethodOptions: [],
  etco2TypeOptions: [],
  assessedByOptions: [],
  neuroLocOptions: [],
  strokeScaleOptions: [],
  strokeScaleScoreOptions: [],
  respirationRateEffortOptions: [],
  painScaleOptions: [],
  withdrawalScaleOptions: [],
  withdrawScaleTypeOptions: [],
  painQualityOnsetUnitOptions: [],
  painQualityFieldOptions: {},
  sedationScaleOptions: [],
  eyeOpeningResponseOptions: [],
  verbalResponseOptions: [],
  motorResponseOptions: [],
  protocolOptions: [],
  raceStrokeScaleQuestionAnswers: [],
  nihPositiveStrokeScaleQuestionAnswers: [],
  apgarAppearanceOptions: [],
  apgarPulseOptions: [],
  apgarGrimaceOptions: [],
  apgarActivityOptions: [],
  apgarRespirationOptions: [],
  strokeScaleConfigOptions: [],
  customStrokeScaleScoreOptions: [],
  additionalPainScaleOptions: [],
}

export const initialAddMedicationAdministeredOptionsState: IAddMedicationAdministeredOptionsState = {
  doseUnitOptions: [],
  rateUnitOptions: [],
  routeOptions: [],
  responseOptions: [],
  performedByOptions: [],
  medicationsOptions: [],
  authorizationOptions: [],
  complicationsOptions: [],
  administeredByAnotherUnitOptions: [],
}

export const initialPatientAllergiesOptionsState: IPatientAllergiesOptionsState = {
  patientAllergies: [],
  chunkedPatientAllergyOptions: [],
  transformedChunkedPatientAllergyOptions: [],
  medicationsAllergiesOptions: [],
  foodEnvironmentalAllergiesOptions: [],
}

export const initialPatientMedicationsOptionsState: IPatientMedicationsOptionsState = {
  doseUnitsOptions: [],
  routeOptions: [],
  frequencyOptions: [],
  medicationsOptions: [],
  medicationsCommonOptions: [],
}

export const initialCardiacOptionsState: ICardiacOptionsState = {
  actionOptions: [],
  leadChangeOptions: [],
  defibTypeOptions: [],
  typeOptions: [],
  pacingModeOptions: [],
  compressionRateOptions: [],
  locationOptions: [],
  mechanicalCprTypeOptions: [],
}

export const initialImagingUltrasoundOptionsState: IImagingUltrasoundOptionsState = {
  typeOptions: [],
  imagingUltrasoundLocationOptions: [],
  findingsOptions: [],
}

export const initialDrainOptionsState: IDrainOptionsState = {
  actionOptions: [],
  procedureOptions: [],
  chestSuctionOptions: [],
  csfColorOptions: [],
  drainSuctionOptions: [],
  foleyColorOptions: [],
  sideOptions: [],
  sizeUnitOptions: [],
  ileostomyColostomyOptions: [],
  locationOptions: [],
  intercostalSpaceOptions: [],
}
export const initialPatientDemographicsOptionsState: IPatientDemographicsOptionsState = {
  emailTypeOptions: [],
  phoneTypeOptions: [],
  ageUnitOptions: [],
  suffixOptions: [],
  triageColorOptions: [],
  weightUnitOptions: [],
  heightUnitOptions: [],
  sexOptions: [],
  genderOptions: [],
  raceOptions: [],
  bloodTypeOptions: [],
  dLStateOptions: [],
  stateOptions: [],
  patientCountyOptions: [],
  countryOptions: [],
  number: '',
  phoneType: null,
  email: '',
  emailType: null,
  phoneDetail: null,
  dnrOptions: [],
  physicianTypeOptions: [],
  barriersToCareOptions: [],
  preferredLanguageOptions: [],
  residenceOptions: [],
  altHomeResidenceOptions: [],
}

export const initialEmployerOptionsState: IEmployerOptionsState = {
  industryOptions: [],
  occupationOptions: [],
  employerCountyOptions: [],
}

export const initialTripInformationOptionsState: ITripInformationOptionsState = {
  baseOptions: [],
  unitOptions: [],
  staffingLevelOptions: [],
  shiftOptions: [],
  registrationTailOptions: [],
  dispatchPriorityOptions: [],
  emdPerformedOptions: [],
  typeofServiceOptions: [],
  scheduledOptions: [],
  patientCategoryOptions: [],
  dispatchedAsOptions: [],
  dispositionOptions: [],
  unitDispositionOptions: [],
  patientEvaluationOptions: [],
  crewDispositionOptions: [],
  transportDispositionOptions: [],
  refusalReleaseReasonOptions: [],
  ambulanceTransportCodeOptions: [],
  massCasualtyOptions: [],
  vehicleGridOptions: [],
  emsVehicleOptions: [],
  emsRegTailNumberOptions: [],
  callTypeOptions: [],
  standByPurposeOptions: [],
  teamOptions: [],
  teamCareOnlyOptions: [],
  equipmentOptions: [],
  providerRolesOptions: [],
  flightPlanOptions: [],
}

export const initialPickupAddressOptionsState: IPickupAddressOptionsState = {
  locationTypeOptions: [],
  otherTypeOptions: [],
  responseModeOptions: [],
  responseModeCustomOptions: [],
  stateOptions: [],
  pickUpAndDestinationCountyOptions: [],
  countryOptions: [],
  hospitalUnitOptions: [],
  hospitalNameOptions: [],
  emsNameOptions: [],
  sceneGridOptions: [],
  modeDescriptorsOptions: [],
  commonAddressesOptions: [],
}

export const initialDestinationAddressOptionsState: IDestinationAddressOptionsState = {
  modeDescriptorsOptions: [],
  destinationBasisOptions: [],
  capabilities: [],
  hospitalOptions: [],
  emsOptions: [],
  transportModeOptions: [],
  transportModeCustomOptions: [],
}

export const initialAirwayOptionsState: IAirwayOptionsState = {
  actionOptions: [],
  viaOptions: [],
  verificationMethodOptions: [],
  airwayComplicationsOptions: [],
  airTemperatureUnitOptions: [],
  reasonsForFailureOptions: [],
}

export const initialChildbirthOBOptionsState: IChildbirthOBOptionsState = {
  actionOptions: [],
  variabilityOptions: [],
  accelerationsOptions: [],
  decelerationOptions: [],
  ucStrengthOptions: [],
  dtrOptions: [],
}

export const initialInitiateIvOptionsState: IInitiateIvOptionsState = {
  siteOptions: [],
  typeOptions: [],
}

export const initialImmobilizationOptionsState: IImmobilizationOptionsState = {
  siteOptions: [],
  assessmentOptions: [],
  devicesUsedOptions: [],
  optionOptions: [],
}

export const initialMedicalConsultOptionsState: IMedicalConsultOptionsState = {
  physicianOptions: [],
  methodOptions: [],
  facilityOptions: [],
}

export const initialOperationsOptionsState: IOperationsOptionsState = {
  weightUnitOptions: [],
  jointCommissionTimeOutOptions: [],
}

export const initialRescueOptionsState: IRescueOptionsState = {
  typesOptions: [],
  hydraulicsOptions: [],
  toolsOptions: [],
  rehabOptions: [],
  activationsOptions: [],
}

export const initialHospitalNotifyOptionsState: IHospitalNotifyOptionsState = {
  methodOptions: [],
  alertOptions: [],
  potentialRegistryOptions: [],
}

export const initialWoundCareOptionsState: IWoundCareOptionsState = {
  actionsOptions: [],
  siteOptions: [],
}

export const initialAuthorizationInformationOptionsState: IAuthorizationInformationOptionState = {
  interfacilityTransferOptions: [],
}

export const initialPaymentInformationOptionsState: IPaymentInformationOptionState = {
  primaryMethodOfPaymentOptions: [],
  x12PayerTypeOptions: [],
  priorAuthorizationPayerOptions: [],
}

export const initialVentilatorOptionsState: IVentilatorOptionsState = {
  modeOptions: [],
  breathTypeOptions: [],
  actionOptions: [],
  airTemperatureUnitOptions: [],
  previousVentilatorState: initialVentilatorState,
}

export const initialCriticalCareOptionsState: ICriticalCareOptionsState = {
  actionOptions: [],
  siteOptions: [],
  iabpAugmentationOptions: [],
  taskOptions: [],
  iabpFrequencyOptions: [],
  insertionSiteOptions: [],
  triggerUtilizedOptions: [],
  slowGasLeakOptions: [],
  autoManualOptions: [],
}

export const initialSignatureOptionsState: ISignatureOptionsState = {
  sectionOptions: [],
  signatureTypeOptions: [],
  sectionOneSignatureTypes: [],
  sectionTwoSignatureTypes: [],
  sectionThreeSignatureTypes: [],
  headerText: '',
  acknowledgmentText: '',
  sectionIText: '',
  sectionIIText: '',
  sectionIIIText: '',
  selectedCrewMembers: [],
  signatureSecTwoPatientUnableToSignOptions: [],
  customSignatureOptions: [],
  customSignatureTypeOptions: [],
  customSignatureTranformedOptions: [],
  isStandardSignatureConfigured: false,
  sectionTwoAuthorizedRepresentativeOptions: [],
}

export const initialConfigurationOptionsState: IConfigurationOptionsState = {
  serviceModules: [],
  timeZoneOptions: [],
}

export const initialCadImportOptionsState: ICadImportOptionsState = {
  data: [],
}

export const initialCcHpiOptionsState: ICcHpiOptionsState = {
  patientActivityOptions: [],
  reasonForEncounterOptions: [],
  initialPatientAcuityOptions: [],
  drugsAndAlcoholOptions: [],
  drugsAndAlcoholIndicatorsOptions: [],
  arrestPresentOptions: [],
  whoWitnessedOptions: [],
  etiologyOptions: [],
  therapeuticHypothermiaOptions: [],
  initialRhythmOptions: [],
  cprPriorEmsArrivalOptions: [],
  firstCprOptions: [],
  cprByOptions: [],
  cprTypeOptions: [],
  resuscitationOptions: [],
  aedUseOptions: [],
  firstAedByOptions: [],
  aedByOptions: [],
  defibTypeOptions: [],
  defibByOptions: [],
  discReasonOptions: [],
  returnCirculationOptions: [],
  destRhythmOptions: [],
  arrestResultOptions: [],
  intentionalOptions: [],
  traumaTriageCriteriaHighRiskOptions: [],
  traumaTriageCriteriaModerateRiskOptions: [],
  injurycauseOptions: [],
  mechanismOptions: [],
  safetyEquipmentOptions: [],
  fallsurfaceOptions: [],
  landedonOptions: [],
  workrelatedOptions: [],
  airbagDeployedOptions: [],
  vehicleImpactSiteOptions: [],
  locationOfPatientInVehicleOptions: [],
  extricationRequiredOptions: [],
  ccDurationUnitsOptions: [],
  scDurationUnitsOptions: [],
  ocDurationUnitsOptions: [],
  alsAssessmentOptions: [],
  dtWitnessedPNNVOptions: [],
}

export const initialDiagnosisOptionsState: IDiagnosisOptionsState = {
  systemOptions: [],
  symptomsOptions: [],
  impressionsOptions: [],
  anatomicLocationOptions: [],
  finalPatientAcuityOptions: [],
  conditionAtDestinationOptions: [],
}

export const patientInsuredOption: IInsuredOption = {
  id: 0,
  ptid: null,
  name: 'Patient',
}

export const initialInsuranceInformationOptionsState: IInsuranceInformationOptionsState = {
  priorityOptions: [],
  insuredOptions: [patientInsuredOption],
}

export const initialRelationshipsAndGuarantorsOptionsState: IRelationshipsAndGuarantorsOptionsState = {
  relationshipOptions: [],
  suffixOptions: [],
  ageUnits: [],
  driversLicenseStateOptions: [],
}

export const initialPcsInformationOptionsState: IPcsInformationOptionsState = {
  nppFormOptions: [],
  consentFormSignedOptions: [],
  medicalNecessitySignedOptions: [],
  pcsReasonOptions: [],
  pcsProviderTypeOptions: [],
}

export const initialCmsInformationOptionsState: ICmsInformationOptionsState = {
  filteredCmsConditionCodeOptions: [],
  cmsConditionCodeOptions: [],
  conditionCodeModifierOptions: [],
  cmsTransportReasonOptions: [],
  ambulanceConditionIndicatorOptions: [],
}

export const initialCameraAttachmentsOptions: ICameraAttachmentsOptionsState = {
  categoryOptions: [],
}

export const initialFactorsAffectingCareOptionsState: IFactorsAffectingCareOptionsState = {
  dispatchFactorsOptions: [],
  responseFactorsOptions: [],
  sceneFactorsOptions: [],
  transportFactorsOptions: [],
  turnAroundFactorsOptions: [],
  factorsOptions: [],
}

export const initialExposureOptionsState: IExposureOptionsState = {
  exposureEquipmentOptions: [],
  exposureTypeOptions: [],
  exposedToOptions: [],
  exposureCrewOptions: [],
  suspectedExposureOptions: [],
}

export const initialSceneOptionsState: ISceneDescriptionOptionsState = {
  firstOnSceneOptions: [],
  levelCarePerProtocolOptions: [],
  prOtherAgenciesOptions: [],
  transferOfCareOptions: [],
  prDisasterOptions: [],
  prPtMovedViaOptions: [],
  prPtPositionOptions: [],
  prPtMovedFromOptions: [],
  prTransportAssessOptions: [],
  prDispoInstructionsOptions: [],
  otherAgencyNameOptions: [],
  otherAgencyTypeOptions: [],
}

export const initialAssessmentAirwayOptions: IInitialAssessmentAirwayOptions = {
  airStatusOptions: [],
  airTypeOptions: [],
  airByOptions: [],
  airOutcomeOptions: [],
  prAirwayVerificationAssessOptions: [],
  prAirwayAssessOptions: [],
  airBroselowOptions: [],
  airEttSizeUnitOptions: [],
}
export const initialRespiratoryOptionsState: IRespiratoryOptionsState = {
  breathSoundLeftOptions: [],
  breathSoundRightOptions: [],
  respEffortOptions: [],
  respViaOptions: [],
  respPerformByOptions: [],
  respOutcomeOptions: [],
  respExamOptions: [],
}

export const initialObstetricsOptionState: IObstetricsOptionsState = {
  isPatientPregnantOptions: [],
  gestationAgeWeeksOptions: [],
  gestationAgeDaysOptions: [],
  bloodyShowOptions: [],
  effacementOptions: [],
  prenatalCareOptions: [],
  membranesOptions: [],
  maternalMedicationsAdministeredOptions: [],
}

export const initialPTSOptionsState: IPTSOptionsState = {
  ptsSizeOptions: [],
  ptsAirwayOptions: [],
  ptsBpOptions: [],
  ptsCnsOptions: [],
  ptsSkelOptions: [],
  ptsWoundOptions: [],
}

export const initialRTSOptionsState: IRTSOptionsState = {
  rtsSysBpOptions: [],
  rtsRespRateOptions: [],
}

export const initialWasPatientImm: IWasPatientImmOptionsState = {
  wasPatientImmobilizedPerformedByOptions: [],
  wasPatientImmobilizedOutcomeOptions: [],
}

export const initialGCSOptions: IGCSOptionsState = {
  gcsQualifierOptions: [],
  gcsEyeResponseOptions: [],
  gcsVerbalResponseOptions: [],
  gcsMotorResponseOptions: [],
}

export const initialTitrateOptionsState: ITitrateOptionsState = {
  medicationOptions: [],
  rateOptions: [],
  routeOptions: [],
}

export const initialLabsOptionsState: ILabsOptionsState = {
  labsConfigOptions: [],
  abgAccessOptions: [],
}

export const initialPnPocedureOptionsState: IPertinentNegativeProcedureOptionsState = {
  pertinentNegativeProcedureOptions: [],
}

export const initialSctOptionsState: ISctOptionsState = {
  sctProcsOptions: [],
  sctMedsOptions: [],
}

export const initialImmunizationOptionsState: IImmunizationOptionsState = {
  immunizationStatusOptions: [],
  immunizationTypeOptions: [],
  immunizationYearOptions: [],
}

export const initialRulesOptionsState: IRulesOptionsState = {
  standardRules: [],
  xsdRules: [],
  nationalRules: [],
  stateRules: [],
  serviceRules: [],
  indexedStandardRules: {},
  indexedXsdRules: {},
  indexedNationalRules: {},
  indexedStateRules: {},
  indexedServiceRules: {},
  rulesUtilsModule: null,
}

export const initialburnOptionsState: IBurnOptionsState = {
  burnTypeOptions: [],
}

export const initialBodySurveyState: IBodySurveyOptions = {
  examValueOptions: [],
  selectedExamOptions: [],
  bodyPartsOptions: [],
  generalExtremitiesOptions: [],
  skinOptions: [],
  mentalExamOptions: [],
  neuroExamOptions: [],
  cardiacExamOptions: [],
  assessmentDefaultOptions: [],
}

export const initialBloodProductAdministrationOptionsState: IBloodProductAdministrationOptionsState = {
  ptIdVerifiedOptions: [],
  clinicalIndicatorOptions: [],
  crossMatchedOptions: [],
  transfusionConsentOptions: [],
  bloodProductTypeOptions: [],
  bloodProductOptions: [],
  bloodProductRouteOptions: [],
  transfusionOrderOptions: [],
  impliedEmergentConsentReasonOptions: [],
}

export const initialVentricularAssistTypeOptionsState: IVentricularAssistTypeOptions = {
  vadTypeOptions: [],
  vadAlarmsOptions: [],
  vadSiteAssessmentOptions: [],
  vadCatheterSizeOptions: [],
  vadPlacementConfirmedByOptions: [],
  vadInsertLocationOptions: [],
  vadMotorCurrentWaveformCharacteristicsOptions: [],
  vadPlacementSignalWaveformCharacteristicsOptions: [],
  vadPlacementLocationOptions: [],
  vadPowerTypeOptions: [],
  vadBackupOptions: [],
  vadBatteryStatusOptions: [],
  vadFlowTypeOptions: [],
  vadIndicationOptions: [],
  vadMakeModelOptions: [],
  vadMakeModelImpellaOptions: [],
  vadPLevelOptions: [],
}

export const initialGenericOptions: IGenericOptions = {
  yesNoOptions: [],
}

export const initialAssessmentOptionState: IAssessmentProcedureOptionsState = {
  neuroFacialOptions: [],
  neuroSpeechOptions: [],
  neuroMotorOptions: [],
  neuroGazeOptions: [],
  neuroLimbOptions: [],
  actionOptions: [],
  sepsisIndicatorsOptions: [],
  customActionFieldsOptions: [],
  customActionFieldsAnswersOptions: [],
}

export const initialAllPNNVOptionsState: IAllPNNVOptionsState = {
  'eArrest.14': [],
  'eExam.01': [],
  'eExam.02': [],
  'eExam.04': [],
  'eExam.05': [],
  'eExam.06': [],
  'eExam.07': [],
  'eExam.08': [],
  'eExam.09': [],
  'eExam.11': [],
  'eExam.12': [],
  'eExam.14': [],
  'eExam.16': [],
  'eExam.18': [],
  'eExam.19': [],
  'eExam.20': [],
  'eHistory.06': [],
  'eHistory.08': [],
  'eHistory.12': [],
  'eHistory.17': [],
  'eHistory.18': [],
  'eInjury.04': [],
  'eMedications.03': [],
  'eNarrative.01': [],
  'eOutcome.09': [],
  'eOutcome.10': [],
  'eOutcome.11': [],
  'eOutcome.12': [],
  'eOutcome.13': [],
  'eOutcome.16': [],
  'eOutcome.18': [],
  'eOutcome.19': [],
  'eOutcome.20': [],
  'ePatient.02': [],
  'ePatient.03': [],
  'ePatient.05': [],
  'ePatient.06': [],
  'ePatient.12': [],
  'ePatient.14': [],
  'ePatient.17': [],
  'ePatient.18': [],
  'ePatient.25': [],
  'eProcedures.03': [],
  'eProcedures.14': [],
  'eSituation.01': [],
  'eSituation.18': [],
  'eVitals.03': [],
  'eVitals.06': [],
  'eVitals.07': [],
  'eVitals.10': [],
  'eVitals.12': [],
  'eVitals.14': [],
  'eVitals.16': [],
  'eVitals.17': [],
  'eVitals.18': [],
  'eVitals.19': [],
  'eVitals.20': [],
  'eVitals.21': [],
  'eVitals.23': [],
  'eVitals.24': [],
  'eVitals.27': [],
  'eVitals.29': [],
  'eVitals.31': [],
  'eVitals.32': [],
  'eVitals.33': [],
  'eVitals.913': [],
  'eTimes.01': [],
  'eTimes.02': [],
  'eTimes.05': [],
  'eTimes.06': [],
  'eTimes.07': [],
  'eTimes.08': [],
  'eTimes.09': [],
  'eTimes.11': [],
  'eTimes.12': [],
  'ePatient.15': [],
  'eAirway.08': [],
}

export const initialNemsisCustomDataOptionsState: INemsisCustomDataOptions = {
  customDataWithState: [],
  customConfigGroupOptions: [],
  hideNemsisCustomOption: false,
}

export const initialSpecialReportOptionsState: ISpecialReportOptionsState = {
  categories: [],
  subCategories: [],
  specialReportData: null,
}

export const initialFillablePDFOptionsState: IFillablePDFOptionsState = {
  metadata: null,
  bindings: null,
}

export const initialPulsaraOptionsState: IPulsaraOptionsState = {
  pulsaraDateRangeOptions: [],
}

export const initialOptionsState: IOptionsState = {
  intubationOptions: initialIntubationOptionsState,
  patientMedicalHistoryOptions: initialPatientMedicalHistoryOptionsState,
  patientMedicationsOptions: initialPatientMedicationsOptionsState,
  cardiacOptions: initialCardiacOptionsState,
  imagingUltrasoundOptions: initialImagingUltrasoundOptionsState,
  vitalOptions: initialVitalOptionsState,
  addMedicationAdministeredOptions: initialAddMedicationAdministeredOptionsState,
  patientAllergiesOptions: initialPatientAllergiesOptionsState,
  patientDemographicsOptions: initialPatientDemographicsOptionsState,
  employerOptions: initialEmployerOptionsState,
  tripInformationOptions: initialTripInformationOptionsState,
  pickupAddressOptions: initialPickupAddressOptionsState,
  destinationAddressOptions: initialDestinationAddressOptionsState,
  airwayOptions: initialAirwayOptionsState,
  childbirthOBOptions: initialChildbirthOBOptionsState,
  initiateIvOptions: initialInitiateIvOptionsState,
  immobilizationOptions: initialImmobilizationOptionsState,
  medicalConsultOptions: initialMedicalConsultOptionsState,
  operationsOptions: initialOperationsOptionsState,
  rescueOptions: initialRescueOptionsState,
  hospitalNotifyOptions: initialHospitalNotifyOptionsState,
  woundCareOptions: initialWoundCareOptionsState,
  ventilatorOptions: initialVentilatorOptionsState,
  signatureOptions: initialSignatureOptionsState,
  configurationOptions: initialConfigurationOptionsState,
  initialPatientAllergiesState: [],
  cadImportOptions: initialCadImportOptionsState,
  ccHpiOptions: initialCcHpiOptionsState,
  insuranceInformationOptions: initialInsuranceInformationOptionsState,
  relationshipsAndGuarantorsOptions: initialRelationshipsAndGuarantorsOptionsState,
  pcsInformationOption: initialPcsInformationOptionsState,
  authorizationInformationOptions: initialAuthorizationInformationOptionsState,
  cmsInformationOptions: initialCmsInformationOptionsState,
  paymentInformationOptions: initialPaymentInformationOptionsState,
  cameraAttachmentsOptions: initialCameraAttachmentsOptions,
  factorsAffectingCareOptions: initialFactorsAffectingCareOptionsState,
  sceneDescriptionOptions: initialSceneOptionsState,
  assessmentAirwayOptions: initialAssessmentAirwayOptions,
  respiratoryOptions: initialRespiratoryOptionsState,
  neuroOptions: initialNeuroOptionsState,
  ptsOptions: initialPTSOptionsState,
  rtsOptions: initialRTSOptionsState,
  wasPatientImmobilizedOptions: initialWasPatientImm,
  gcsOptions: initialGCSOptions,
  cardioOptions: initialCardioOptionsState,
  drainOptions: initialDrainOptionsState,
  titrateOptions: initialTitrateOptionsState,
  labsOptions: initialLabsOptionsState,
  pnProcedureOptions: initialPnPocedureOptionsState,
  sctOptions: initialSctOptionsState,
  pnMedicationOptions: initialPnMedicationOptionsState,
  exposureOptions: initialExposureOptionsState,
  immunizationOptions: initialImmunizationOptionsState,
  rulesOptions: initialRulesOptionsState,
  diagnosisOptions: initialDiagnosisOptionsState,
  obstetricsOptions: initialObstetricsOptionState,
  burnOptions: initialburnOptionsState,
  bodySurveyOptions: initialBodySurveyState,
  allPNNVOptions: initialAllPNNVOptionsState,
  nemsisCustomDataOptions: initialNemsisCustomDataOptionsState,
  bloodProductAdministrationOptions: initialBloodProductAdministrationOptionsState,
  ventricularAssistTypeOptions: initialVentricularAssistTypeOptionsState,
  genericOptions: initialGenericOptions,
  criticalCareOptions: initialCriticalCareOptionsState,
  assessmentProcedureOptions: initialAssessmentOptionState,
  specialReportOptions: initialSpecialReportOptionsState,
  customFluidsOptions: [],
  fillablePDFOptions: initialFillablePDFOptionsState,
  pulsaraOptions: initialPulsaraOptionsState,
}

export function optionsReducer(state: IOptionsState = initialOptionsState, action: IOptionsStateAction): IOptionsState {
  switch (action.type) {
    case OptionsConstants.SET_ASSESSED_BY_OPTIONS:
      return {
        ...state,
        intubationOptions: {
          ...state.intubationOptions,
          assessedByOptions: action.assessedByOptions,
        },
      }
    case OptionsConstants.SET_DISTANCE_UNIT_OPTIONS:
      return {
        ...state,
        intubationOptions: {
          ...state.intubationOptions,
          distanceUnitOptions: action.distanceUnitOptions,
        },
      }
    case OptionsConstants.SET_METHOD_OPTIONS:
      return {
        ...state,
        intubationOptions: {
          ...state.intubationOptions,
          methodOptions: action.methodOptions,
        },
      }
    case OptionsConstants.SET_SECURED_VIA_OPTIONS:
      return {
        ...state,
        intubationOptions: {
          ...state.intubationOptions,
          securedViaOptions: action.securedViaOptions,
        },
      }
    case OptionsConstants.SET_VERIFIED_BY_OPTIONS:
      return {
        ...state,
        intubationOptions: {
          ...state.intubationOptions,
          verifiedByOptions: action.verifiedByOptions,
        },
      }
    case OptionsConstants.SET_VERIFICATION_VIA_OPTIONS:
      return {
        ...state,
        intubationOptions: {
          ...state.intubationOptions,
          verificationViaOptions: action.verificationViaOptions,
        },
      }
    case OptionsConstants.SET_AIRWAY_PLACEMENT_TECHNIQUE_OPTIONS:
      return {
        ...state,
        intubationOptions: {
          ...state.intubationOptions,
          airwayPlacementTechniqueOptions: action.airwayPlacementTechniqueOptions,
        },
      }
    case OptionsConstants.SET_RSI_PROTOCOL_OPTIONS:
      return {
        ...state,
        intubationOptions: {
          ...state.intubationOptions,
          rSIProtocolOptions: action.rSIProtocolOptions,
        },
      }
    case OptionsConstants.SET_MALLAMPATI_OPTIONS:
      return {
        ...state,
        intubationOptions: {
          ...state.intubationOptions,
          mallampatiOptions: action.mallampatiOptions,
        },
      }
    case OptionsConstants.SET_SELLICK_MANEUVER_OPTIONS:
      return {
        ...state,
        intubationOptions: {
          ...state.intubationOptions,
          sellickManeuverOptions: action.sellickManeuverOptions,
        },
      }
    case OptionsConstants.SET_LARYNGOSCOPIC_GRADE_OPTIONS:
      return {
        ...state,
        intubationOptions: {
          ...state.intubationOptions,
          laryngoscopicGradeOptions: action.laryngoscopicGradeOptions,
        },
      }
    case OptionsConstants.SET_CUFF_FILL_OPTIONS:
      return {
        ...state,
        intubationOptions: {
          ...state.intubationOptions,
          cuffFillOptions: action.cuffFillOptions,
        },
      }
    case OptionsConstants.SET_LARYNGOSCOPE_BLADE_OPTIONS:
      return {
        ...state,
        intubationOptions: {
          ...state.intubationOptions,
          laryngoscopeBladeOptions: action.laryngoscopeBladeOptions,
        },
      }
    case OptionsConstants.SET_INDICATIONS_OPTIONS:
      return {
        ...state,
        intubationOptions: {
          ...state.intubationOptions,
          indicationsOptions: action.indicationsOptions,
        },
      }
    case OptionsConstants.SET_AIRWAY_COMPLICATIONS_OPTIONS:
      return {
        ...state,
        intubationOptions: {
          ...state.intubationOptions,
          airwayComplicationsOptions: action.airwayComplicationsOptions,
        },
      }
    case OptionsConstants.SET_AIRWAY_TEMPERTURE_UNIT_OPTIONS:
      return {
        ...state,
        airwayOptions: {
          ...state.airwayOptions,
          airTemperatureUnitOptions: action.airTemperatureUnitOptions,
        },
      }
    case OptionsConstants.SET_PROCEDURE_COMPLICATIONS_OPTIONS:
      return {
        ...state,
        intubationOptions: {
          ...state.intubationOptions,
          procedureComplicationsOptions: action.procedureComplicationsOptions,
        },
      }
    case OptionsConstants.SET_RESPONSE_OPTIONS:
      return {
        ...state,
        intubationOptions: {
          ...state.intubationOptions,
          responseOptions: action.responseOptions,
        },
      }
    case OptionsConstants.SET_STYLET_USED_OPTIONS:
      return {
        ...state,
        intubationOptions: {
          ...state.intubationOptions,
          styletUsedOptions: action.styletUsedOptions,
        },
      }
    case OptionsConstants.SET_AUTHORIZATION_OPTIONS:
      return {
        ...state,
        intubationOptions: {
          ...state.intubationOptions,
          authorizationOptions: action.authorizationOptions,
        },
        addMedicationAdministeredOptions: {
          ...state.addMedicationAdministeredOptions,
          authorizationOptions: action.authorizationOptions,
        },
      }
    case OptionsConstants.SET_REASONS_FOR_FAILURE_OPTIONS:
      return {
        ...state,
        intubationOptions: {
          ...state.intubationOptions,
          reasonsForFailureOptions: action.reasonsForFailureOptions,
        },
        airwayOptions: {
          ...state.airwayOptions,
          reasonsForFailureOptions: action.reasonsForFailureOptions,
        },
      }
    case OptionsConstants.SET_CHUNKED_PATIENT_MEDICAL_HISTORY:
      return {
        ...state,
        patientMedicalHistoryOptions: {
          ...state.patientMedicalHistoryOptions,
          chunkedPatientMedicalHistoryOptions: [
            ...state.patientMedicalHistoryOptions.chunkedPatientMedicalHistoryOptions,
            ...action.chunkedPatientMedicalHistoryOptions,
          ],
        },
      }
    case OptionsConstants.SET_TRANSFORMED_CHUNKED_PATIENT_MEDICAL_HISTORY:
      return {
        ...state,
        patientMedicalHistoryOptions: {
          ...state.patientMedicalHistoryOptions,
          transformedChunkedPatientMedicalHistoryOptions: action.transformedChunkedPatientMedicalHistoryOptions,
        },
      }
    case OptionsConstants.SET_PATIENT_MEDICAL_HISTORY:
      return {
        ...state,
        patientMedicalHistoryOptions: {
          ...state.patientMedicalHistoryOptions,
          medicalHistoryOptions: action.medicalHistoryOptions,
        },
      }
    case OptionsConstants.SET_FULL_PATIENT_MEDICAL_HISTORY:
      return {
        ...state,
        patientMedicalHistoryOptions: {
          ...state.patientMedicalHistoryOptions,
          medicalHistoryOptionsFullList: action.medicalHistoryOptionsFullList,
        },
      }
    case OptionsConstants.SET_PATIENT_MEDICAL_HISTORY_ICD_NEMSIS_BASIC:
      return {
        ...state,
        patientMedicalHistoryOptions: {
          ...state.patientMedicalHistoryOptions,
          medicalHistoryIcdNemsisBasicOptions: action.medicalHistoryIcdNemsisBasicOptions,
        },
      }
    case OptionsConstants.SET_FULL_PATIENT_MEDICAL_HISTORY_ICD_NEMSIS_BASIC:
      return {
        ...state,
        patientMedicalHistoryOptions: {
          ...state.patientMedicalHistoryOptions,
          medicalHistoryIcdNemsisBasicOptionsFullList: action.medicalHistoryIcdNemsisBasicOptionsFullList,
        },
      }

    case OptionsConstants.SET_OBTAINED_FROM_OPTIONS:
      return {
        ...state,
        patientMedicalHistoryOptions: {
          ...state.patientMedicalHistoryOptions,
          obtainedFromOptions: action.obtainedFromOptions,
        },
      }

    case OptionsConstants.SET_EMERGENCY_INFO_FORM_OPTIONS:
      return {
        ...state,
        patientMedicalHistoryOptions: {
          ...state.patientMedicalHistoryOptions,
          emergencyInfoFormOptions: action.emergencyInfoFormOptions,
        },
      }

    case OptionsConstants.SET_DOSE_UNIT_OPTIONS:
      return {
        ...state,
        patientMedicationsOptions: {
          ...state.patientMedicationsOptions,
          doseUnitsOptions: action.doseUnitOptions,
        },
        addMedicationAdministeredOptions: {
          ...state.addMedicationAdministeredOptions,
          doseUnitOptions: action.doseUnitOptions,
        },
        titrateOptions: {
          ...state.titrateOptions,
          rateOptions: action.doseUnitOptions,
        },
      }
    case OptionsConstants.SET_FREQUENCY_OPTIONS:
      return {
        ...state,
        patientMedicationsOptions: {
          ...state.patientMedicationsOptions,
          frequencyOptions: action.frequencyOptions,
        },
      }
    case OptionsConstants.SET_ROUTE_OPTIONS:
      return {
        ...state,
        patientMedicationsOptions: {
          ...state.patientMedicationsOptions,
          routeOptions: action.routeOptions,
        },
        pnMedicationOptions: {
          ...state.pnMedicationOptions,
          routeOptions: action.routeOptions,
        },
      }
    case OptionsConstants.SET_MEDICATIONS_OPTIONS:
      return {
        ...state,
        patientMedicationsOptions: {
          ...state.patientMedicationsOptions,
          medicationsOptions: action.medicationsOptions,
        },
      }
    case OptionsConstants.SET_COMMON_MEDICATIONS_OPTIONS:
      return {
        ...state,
        patientMedicationsOptions: {
          ...state.patientMedicationsOptions,
          medicationsCommonOptions: action.medicationsCommonOptions,
        },
      }
    case OptionsConstants.SET_ACTION_OPTIONS:
      return {
        ...state,
        cardiacOptions: {
          ...state.cardiacOptions,
          actionOptions: action.actionOptions,
        },
      }
    case OptionsConstants.SET_DRAIN_ACTION_OPTIONS:
      return {
        ...state,
        drainOptions: {
          ...state.drainOptions,
          actionOptions: action.actionOptions,
        },
      }
    case OptionsConstants.SET_DRAIN_PROCEDURE_OPTIONS:
      return {
        ...state,
        drainOptions: {
          ...state.drainOptions,
          procedureOptions: action.procedureOptions,
        },
      }
    case OptionsConstants.SET_DRAIN_SIZE_UNIT_OPTIONS:
      return {
        ...state,
        drainOptions: {
          ...state.drainOptions,
          sizeUnitOptions: action.sizeUnitOptions,
        },
      }
    case OptionsConstants.SET_DRAIN_DRAIN_SUCTION_OPTIONS:
      return {
        ...state,
        drainOptions: {
          ...state.drainOptions,
          drainSuctionOptions: action.drainSuctionOptions,
        },
      }
    case OptionsConstants.SET_DRAIN_CHEST_SUCTION_OPTIONS:
      return {
        ...state,
        drainOptions: {
          ...state.drainOptions,
          chestSuctionOptions: action.chestSuctionOptions,
        },
      }
    case OptionsConstants.SET_DRAIN_FOLEY_COLOR_OPTIONS:
      return {
        ...state,
        drainOptions: {
          ...state.drainOptions,
          foleyColorOptions: action.foleyColorOptions,
        },
      }
    case OptionsConstants.SET_DRAIN_CSF_COLOR_OPTIONS:
      return {
        ...state,
        drainOptions: {
          ...state.drainOptions,
          csfColorOptions: action.csfColorOptions,
        },
      }
    case OptionsConstants.SET_DRAIN_SIDE_OPTIONS:
      return {
        ...state,
        drainOptions: {
          ...state.drainOptions,
          sideOptions: action.sideOptions,
        },
      }

    case OptionsConstants.SET_ILEOSTOMY_COLOSTOMY_OPTIONS:
      return {
        ...state,
        drainOptions: {
          ...state.drainOptions,
          ileostomyColostomyOptions: action.ileostomyColostomyOptions,
        },
      }

    case OptionsConstants.SET_DRAIN_LOCATION_OPTIONS:
      return {
        ...state,
        drainOptions: {
          ...state.drainOptions,
          locationOptions: action.locationOptions,
        },
      }

    case OptionsConstants.SET_DRAIN_INTERCOSTAL_SPACE_OPTIONS:
      return {
        ...state,
        drainOptions: {
          ...state.drainOptions,
          intercostalSpaceOptions: action.intercostalSpaceOptions,
        },
      }

    case OptionsConstants.SET_LEAD_CHANGE_OPTIONS:
      return {
        ...state,
        cardiacOptions: {
          ...state.cardiacOptions,
          leadChangeOptions: action.leadChangeOptions,
        },
      }
    case OptionsConstants.SET_DEFIB_TYPE_OPTIONS:
      return {
        ...state,
        cardiacOptions: {
          ...state.cardiacOptions,
          defibTypeOptions: action.defibTypeOptions,
        },
      }
    case OptionsConstants.SET_TYPE_OPTIONS:
      return {
        ...state,
        cardiacOptions: {
          ...state.cardiacOptions,
          typeOptions: action.typeOptions,
        },
      }
    case OptionsConstants.SET_PACING_MODE_OPTIONS:
      return {
        ...state,
        cardiacOptions: {
          ...state.cardiacOptions,
          pacingModeOptions: action.pacingModeOptions,
        },
      }
    case OptionsConstants.SET_COMPRESSION_RATE_OPTIONS:
      return {
        ...state,
        cardiacOptions: {
          ...state.cardiacOptions,
          compressionRateOptions: action.compressionRateOptions,
        },
      }
    case OptionsConstants.SET_LOCATION_OPTIONS:
      return {
        ...state,
        cardiacOptions: {
          ...state.cardiacOptions,
          locationOptions: action.locationOptions,
        },
      }
    case OptionsConstants.SET_IMAGING_ULTRASOUND_LOCATION_OPTIONS:
      return {
        ...state,
        imagingUltrasoundOptions: {
          ...state.imagingUltrasoundOptions,
          imagingUltrasoundLocationOptions: action.imagingUltrasoundLocationOptions,
        },
      }
    case OptionsConstants.SET_IMAGING_ULTRASOUND_FINDINGS_OPTIONS:
      return {
        ...state,
        imagingUltrasoundOptions: {
          ...state.imagingUltrasoundOptions,
          findingsOptions: action.findingsOptions,
        },
      }
    case OptionsConstants.SET_IMAGING_ULTRASOUND_TYPE_OPTIONS:
      return {
        ...state,
        imagingUltrasoundOptions: {
          ...state.imagingUltrasoundOptions,
          typeOptions: action.typeOptions,
        },
      }
    case OptionsConstants.SET_MECHANICAL_CPR_TYPE_OPTIONS:
      return {
        ...state,
        cardiacOptions: {
          ...state.cardiacOptions,
          mechanicalCprTypeOptions: action.mechanicalCprTypeOptions,
        },
      }
    case OptionsConstants.SET_BLOOD_PRESSURE_METHOD_OPTIONS:
      return {
        ...state,
        vitalOptions: {
          ...state.vitalOptions,
          bloodPressureMethodOptions: action.bloodPressureMethodOptions,
        },
      }
    case OptionsConstants.SET_RHYTHM_OPTIONS:
      return {
        ...state,
        vitalOptions: {
          ...state.vitalOptions,
          rhythmOptions: action.rhythmOptions,
        },
      }
    case OptionsConstants.SET_REGULARITY_OPTIONS:
      return {
        ...state,
        vitalOptions: {
          ...state.vitalOptions,
          regularityOptions: action.regularityOptions,
        },
      }
    case OptionsConstants.SET_ECG_TYPE_OPTIONS:
      return {
        ...state,
        vitalOptions: {
          ...state.vitalOptions,
          ecgTypeOptions: action.ecgTypeOptions,
        },
      }
    case OptionsConstants.SET_ECG_TYPE_METHOD_OPTIONS:
      return {
        ...state,
        vitalOptions: {
          ...state.vitalOptions,
          ecgTypeMethodOptions: action.ecgTypeMethodOptions,
        },
      }
    case OptionsConstants.SET_HEART_RATE_METHODS_OPTIONS:
      return {
        ...state,
        vitalOptions: {
          ...state.vitalOptions,
          heartRateMethodOptions: action.heartRateMethodOptions,
        },
      }
    case OptionsConstants.SET_NEUROLOC_OPTIONS:
      return {
        ...state,
        vitalOptions: {
          ...state.vitalOptions,
          neuroLocOptions: action.neuroLocOptions,
        },
      }
    case OptionsConstants.SET_STROKE_SCALE_OPTIONS:
      return {
        ...state,
        vitalOptions: {
          ...state.vitalOptions,
          strokeScaleOptions: action.strokeScaleOptions,
        },
      }
    case OptionsConstants.SET_STROKE_SCALE_SCORE_OPTIONS:
      return {
        ...state,
        vitalOptions: {
          ...state.vitalOptions,
          strokeScaleScoreOptions: action.strokeScaleScoreOptions,
        },
      }
    case OptionsConstants.SET_RESPIRATION_RATE_EFFORT_OPTIONS:
      return {
        ...state,
        vitalOptions: {
          ...state.vitalOptions,
          respirationRateEffortOptions: action.respirationRateEffortOptions,
        },
      }
    case OptionsConstants.SET_PAIN_SCALE_OPTIONS:
      return {
        ...state,
        vitalOptions: {
          ...state.vitalOptions,
          painScaleOptions: action.painScaleOptions,
        },
      }
    case OptionsConstants.SET_WITHDRAWAL_SCALE_OPTIONS:
      return {
        ...state,
        vitalOptions: {
          ...state.vitalOptions,
          withdrawalScaleOptions: action.withdrawalScaleOptions,
        },
      }
    case OptionsConstants.SET_WITHDRAWAL_SCALE_TYPE_OPTIONS:
      return {
        ...state,
        vitalOptions: {
          ...state.vitalOptions,
          withdrawScaleTypeOptions: action.withdrawScaleTypeOptions,
        },
      }
    case OptionsConstants.SET_ADDITIONAL_PAIN_SCALE_OPTIONS:
      return {
        ...state,
        vitalOptions: {
          ...state.vitalOptions,
          additionalPainScaleOptions: action.additionalPainScaleOptions,
        },
      }
    case OptionsConstants.SET_PAIN_QUALITY_ONSET_UNIT_OPTIONS:
      return {
        ...state,
        vitalOptions: {
          ...state.vitalOptions,
          painQualityOnsetUnitOptions: action.painQualityOnsetUnitOptions,
        },
      }
    case OptionsConstants.SET_PAIN_QUALITY_FIELD_OPTIONS:
      return {
        ...state,
        vitalOptions: {
          ...state.vitalOptions,
          painQualityFieldOptions: action.painQualityFieldOptions,
        },
      }
    case OptionsConstants.SET_SEDATION_SCALE_OPTIONS:
      return {
        ...state,
        vitalOptions: {
          ...state.vitalOptions,
          sedationScaleOptions: action.sedationScaleOptions,
        },
      }
    case OptionsConstants.SET_TEMPERATURE_METHOD_OPTIONS:
      return {
        ...state,
        vitalOptions: {
          ...state.vitalOptions,
          temperatureMethodOptions: action.temperatureMethodOptions,
        },
      }
    case OptionsConstants.SET_ETCO2_TYPE_OPTIONS:
      return {
        ...state,
        vitalOptions: {
          ...state.vitalOptions,
          etco2TypeOptions: action.etco2TypeOptions,
        },
      }
    case OptionsConstants.SET_VITALS_ASSESSED_BY_OPTIONS:
      return {
        ...state,
        vitalOptions: {
          ...state.vitalOptions,
          assessedByOptions: action.assessedByOptions,
        },
      }
    case OptionsConstants.SET_EYE_OPENING_RESPONSE_OPTIONS:
      return {
        ...state,
        vitalOptions: {
          ...state.vitalOptions,
          eyeOpeningResponseOptions: action.eyeOpeningResponseOptions,
        },
      }
    case OptionsConstants.SET_VERBAL_RESPONSE_OPTIONS:
      return {
        ...state,
        vitalOptions: {
          ...state.vitalOptions,
          verbalResponseOptions: action.verbalResponseOptions,
        },
      }
    case OptionsConstants.SET_MOTOR_RESPONSE_OPTIONS:
      return {
        ...state,
        vitalOptions: {
          ...state.vitalOptions,
          motorResponseOptions: action.motorResponseOptions,
        },
      }
    case OptionsConstants.SET_PROTOCOL_OPTIONS:
      return {
        ...state,
        vitalOptions: {
          ...state.vitalOptions,
          protocolOptions: action.protocolOptions,
        },
      }
    case OptionsConstants.SET_PERFORMED_BY_OPTIONS:
      return {
        ...state,
        addMedicationAdministeredOptions: {
          ...state.addMedicationAdministeredOptions,
          performedByOptions: action.performedByOptions,
        },
      }
    case OptionsConstants.SET_MEDICATION_OPTIONS:
      return {
        ...state,
        addMedicationAdministeredOptions: {
          ...state.addMedicationAdministeredOptions,
          medicationsOptions: action.medicationsOptions,
        },
        titrateOptions: {
          ...state.titrateOptions,
          medicationOptions: action.medicationsOptions,
        },
      }
    case OptionsConstants.SET_RATE_UNIT_OPTIONS:
      return {
        ...state,
        addMedicationAdministeredOptions: {
          ...state.addMedicationAdministeredOptions,
          rateUnitOptions: action.rateUnitOptions,
        },
        pnMedicationOptions: {
          ...state.pnMedicationOptions,
          doseUnitOptions: action.rateUnitOptions,
        },
      }
    case OptionsConstants.SET_MEDICATION_ADMINISTERED_ROUTE_OPTIONS:
      return {
        ...state,
        addMedicationAdministeredOptions: {
          ...state.addMedicationAdministeredOptions,
          routeOptions: action.routeOptions,
        },
        titrateOptions: {
          ...state.titrateOptions,
          routeOptions: action.routeOptions,
        },
      }
    case OptionsConstants.SET_RESPONSE_VALUE_OPTIONS:
      return {
        ...state,
        addMedicationAdministeredOptions: {
          ...state.addMedicationAdministeredOptions,
          responseOptions: action.responseOptions,
        },
      }
    case OptionsConstants.SET_COMPLICATIONS_OPTIONS:
      return {
        ...state,
        addMedicationAdministeredOptions: {
          ...state.addMedicationAdministeredOptions,
          complicationsOptions: action.complicationsOptions,
        },
      }
    case OptionsConstants.SET_PATIENT_ALLERGIES_OPTIONS:
      return {
        ...state,
        patientAllergiesOptions: {
          ...state.patientAllergiesOptions,
          patientAllergies: action.patientAllergies,
        },
      }
    case OptionsConstants.SET_PATIENT_ALLERGIES_FOOD_ENVIRONMENT_BUTTON_WALL_OPTIONS:
      return {
        ...state,
        patientAllergiesOptions: {
          ...state.patientAllergiesOptions,
          foodEnvironmentalAllergiesOptions: action.foodEnvironmentalAllergiesOptions,
        },
      }
    case OptionsConstants.SET_PATIENT_ALLERGIES_MEDICATION_BUTTON_WALL_OPTIONS:
      return {
        ...state,
        patientAllergiesOptions: {
          ...state.patientAllergiesOptions,
          medicationsAllergiesOptions: action.medicationsAllergiesOptions,
        },
      }
    case OptionsConstants.RESET_PATIENT_ALLERGIES_OPTIONS:
      return {
        ...state,
        patientAllergiesOptions: {
          ...initialPatientAllergiesOptionsState,
        },
      }

    case OptionsConstants.SET_BLOOD_TYPE_OPTIONS:
      return {
        ...state,
        patientDemographicsOptions: {
          ...state.patientDemographicsOptions,
          bloodTypeOptions: action.bloodTypeOptions,
        },
      }
    case OptionsConstants.SET_COUNTRY_OPTIONS:
      return {
        ...state,
        patientDemographicsOptions: {
          ...state.patientDemographicsOptions,
          countryOptions: action.countryOptions,
        },
        pickupAddressOptions: {
          ...state.pickupAddressOptions,
          countryOptions: action.countryOptions,
        },
      }
    case OptionsConstants.SET_DL_STATE_OPTIONS:
      return {
        ...state,
        patientDemographicsOptions: {
          ...state.patientDemographicsOptions,
          dLStateOptions: action.dLStateOptions,
        },
        relationshipsAndGuarantorsOptions: {
          ...state.relationshipsAndGuarantorsOptions,
          driversLicenseStateOptions: action.dLStateOptions,
        },
      }
    case OptionsConstants.SET_EMAIL_TYPE_OPTIONS:
      return {
        ...state,
        patientDemographicsOptions: {
          ...state.patientDemographicsOptions,
          emailTypeOptions: action.emailTypeOptions,
        },
      }
    case OptionsConstants.SET_SEX_OPTIONS:
      return {
        ...state,
        patientDemographicsOptions: {
          ...state.patientDemographicsOptions,
          sexOptions: action.sexOptions,
        },
      }
    case OptionsConstants.SET_GENDER_OPTIONS:
      return {
        ...state,
        patientDemographicsOptions: {
          ...state.patientDemographicsOptions,
          genderOptions: action.genderOptions,
        },
      }
    case OptionsConstants.SET_PHONE_TYPE_OPTIONS:
      return {
        ...state,
        patientDemographicsOptions: {
          ...state.patientDemographicsOptions,
          phoneTypeOptions: action.phoneTypeOptions,
        },
      }
    case OptionsConstants.SET_RACE_OPTIONS:
      return {
        ...state,
        patientDemographicsOptions: {
          ...state.patientDemographicsOptions,
          raceOptions: action.raceOptions,
        },
      }
    case OptionsConstants.SET_STATE_OPTIONS:
      return {
        ...state,
        patientDemographicsOptions: {
          ...state.patientDemographicsOptions,
          stateOptions: action.stateOptions,
        },
        pickupAddressOptions: {
          ...state.pickupAddressOptions,
          stateOptions: action.stateOptions,
        },
      }
    case OptionsConstants.SET_PATIENT_COUNTY_OPTIONS:
      return {
        ...state,
        patientDemographicsOptions: {
          ...state.patientDemographicsOptions,
          patientCountyOptions: action.patientCountyOptions,
        },
      }
    case OptionsConstants.SET_RESIDENCE_OPTIONS:
      return {
        ...state,
        patientDemographicsOptions: {
          ...state.patientDemographicsOptions,
          residenceOptions: action.residenceOptions,
        },
      }
    case OptionsConstants.SET_ALT_HOME_RESIDENCE_OPTIONS:
      return {
        ...state,
        patientDemographicsOptions: {
          ...state.patientDemographicsOptions,
          altHomeResidenceOptions: action.altHomeResidenceOptions,
        },
      }
    case OptionsConstants.SET_EMPLOYER_COUNTY_OPTIONS:
      return {
        ...state,
        employerOptions: {
          ...state.employerOptions,
          employerCountyOptions: action.employerCountyOptions,
        },
      }
    case OptionsConstants.SET_PICK_UP_AND_DESTINATION_COUNTY_OPTIONS:
      return {
        ...state,
        pickupAddressOptions: {
          ...state.pickupAddressOptions,
          pickUpAndDestinationCountyOptions: action.pickUpAndDestinationCountyOptions,
        },
      }
    case OptionsConstants.SET_SUFFIX_OPTIONS:
      return {
        ...state,
        patientDemographicsOptions: {
          ...state.patientDemographicsOptions,
          suffixOptions: action.suffixOptions,
        },
        relationshipsAndGuarantorsOptions: {
          ...state.relationshipsAndGuarantorsOptions,
          suffixOptions: action.suffixOptions,
        },
      }
    case OptionsConstants.SET_TRIAGE_COLOR_OPTIONS:
      return {
        ...state,
        patientDemographicsOptions: {
          ...state.patientDemographicsOptions,
          triageColorOptions: action.triageColorOptions,
        },
      }
    case OptionsConstants.SET_WEIGHT_OPTIONS:
      return {
        ...state,
        patientDemographicsOptions: {
          ...state.patientDemographicsOptions,
          weightUnitOptions: action.weightUnitOptions,
        },
        operationsOptions: {
          ...state.operationsOptions,
          weightUnitOptions: action.weightUnitOptions,
        },
      }
    case OptionsConstants.SET_JOINT_COMMISSION_TIMEOUT_OPTIONS:
      return {
        ...state,
        operationsOptions: {
          ...state.operationsOptions,
          jointCommissionTimeOutOptions: action.jointCommissionTimeOutOptions,
        },
      }
    case OptionsConstants.SET_INTERFACILITY_TRANSFER_OPTIONS:
      return {
        ...state,
        authorizationInformationOptions: {
          ...state.authorizationInformationOptions,
          interfacilityTransferOptions: action.interfacilityTransferOptions,
        },
      }
    case OptionsConstants.SET_HEIGHT_OPTIONS:
      return {
        ...state,
        patientDemographicsOptions: {
          ...state.patientDemographicsOptions,
          heightUnitOptions: action.heightUnitOptions,
        },
      }
    case OptionsConstants.SET_AGE_OPTIONS:
      return {
        ...state,
        patientDemographicsOptions: {
          ...state.patientDemographicsOptions,
          ageUnitOptions: action.ageUnitOptions,
        },
      }
    case OptionsConstants.SET_DNR_OPTIONS:
      return {
        ...state,
        patientDemographicsOptions: {
          ...state.patientDemographicsOptions,
          dnrOptions: action.dnrOptions,
        },
      }
    case OptionsConstants.SET_PHYSICIAN_TYPE_OPTIONS:
      return {
        ...state,
        patientDemographicsOptions: {
          ...state.patientDemographicsOptions,
          physicianTypeOptions: action.physicianTypeOptions,
        },
      }
    case OptionsConstants.SET_INDUSTRY_OPTIONS:
      return {
        ...state,
        employerOptions: {
          ...state.employerOptions,
          industryOptions: action.industryOptions,
        },
      }
    case OptionsConstants.SET_OCCUPATION_OPTIONS:
      return {
        ...state,
        employerOptions: {
          ...state.employerOptions,
          occupationOptions: action.occupationOptions,
        },
      }
    case OptionsConstants.SET_BARRIERS_TO_CARE_OPTIONS:
      return {
        ...state,
        patientDemographicsOptions: {
          ...state.patientDemographicsOptions,
          barriersToCareOptions: action.barriersToCareOptions,
        },
      }
    case OptionsConstants.SET_PREFERRED_LANGUAGE_OPTIONS:
      return {
        ...state,
        patientDemographicsOptions: {
          ...state.patientDemographicsOptions,
          preferredLanguageOptions: action.preferredLanguageOptions,
        },
      }
    case OptionsConstants.SET_GUARANTORS_AGE_OPTIONS:
      return {
        ...state,
        relationshipsAndGuarantorsOptions: {
          ...state.relationshipsAndGuarantorsOptions,
          ageUnits: action.ageUnits,
        },
      }
    case OptionsConstants.SET_BASE_OPTIONS:
      return {
        ...state,
        tripInformationOptions: {
          ...state.tripInformationOptions,
          baseOptions: action.baseOptions,
        },
      }
    case OptionsConstants.SET_UNIT_OPTIONS:
      return {
        ...state,
        tripInformationOptions: {
          ...state.tripInformationOptions,
          unitOptions: action.unitOptions,
        },
      }
    case OptionsConstants.SET_STAFFING_LEVEL_OPTIONS:
      return {
        ...state,
        tripInformationOptions: {
          ...state.tripInformationOptions,
          staffingLevelOptions: action.staffingLevelOptions,
        },
      }
    case OptionsConstants.SET_SHIFT_OPTIONS:
      return {
        ...state,
        tripInformationOptions: {
          ...state.tripInformationOptions,
          shiftOptions: action.shiftOptions,
        },
      }
    case OptionsConstants.SET_REGISTRATION_TAIL_OPTIONS:
      return {
        ...state,
        tripInformationOptions: {
          ...state.tripInformationOptions,
          registrationTailOptions: action.registrationTailOptions,
        },
      }
    case OptionsConstants.SET_DISPATCH_PRIORITY_OPTIONS:
      return {
        ...state,
        tripInformationOptions: {
          ...state.tripInformationOptions,
          dispatchPriorityOptions: action.dispatchPriorityOptions,
        },
      }
    case OptionsConstants.SET_EMD_PERFORMED_OPTIONS:
      return {
        ...state,
        tripInformationOptions: {
          ...state.tripInformationOptions,
          emdPerformedOptions: action.emdPerformedOptions,
        },
      }
    case OptionsConstants.SET_TYPE_OF_SERVICE_OPTIONS:
      return {
        ...state,
        tripInformationOptions: {
          ...state.tripInformationOptions,
          typeofServiceOptions: action.typeofServiceOptions,
        },
      }
    case OptionsConstants.SET_STANDBY_PURPOSE_OPTIONS:
      return {
        ...state,
        tripInformationOptions: {
          ...state.tripInformationOptions,
          standByPurposeOptions: action.standByPurposeOptions,
        },
      }
    case OptionsConstants.SET_CALL_TYPE_OPTIONS:
      return {
        ...state,
        tripInformationOptions: {
          ...state.tripInformationOptions,
          callTypeOptions: action.callTypeOptions,
        },
      }
    case OptionsConstants.SET_SCHEDULED_OPTIONS:
      return {
        ...state,
        tripInformationOptions: {
          ...state.tripInformationOptions,
          scheduledOptions: action.scheduledOptions,
        },
      }
    case OptionsConstants.SET_PATIENT_CATEGORY_OPTIONS:
      return {
        ...state,
        tripInformationOptions: {
          ...state.tripInformationOptions,
          patientCategoryOptions: action.patientCategoryOptions,
        },
      }
    case OptionsConstants.SET_DISPATCHED_AS_OPTIONS:
      return {
        ...state,
        tripInformationOptions: {
          ...state.tripInformationOptions,
          dispatchedAsOptions: action.dispatchedAsOptions,
        },
      }
    case OptionsConstants.SET_DISPOSITION_OPTIONS:
      return {
        ...state,
        tripInformationOptions: {
          ...state.tripInformationOptions,
          dispositionOptions: action.dispositionOptions,
        },
      }
    case OptionsConstants.SET_UNIT_DISPOSITION_OPTIONS:
      return {
        ...state,
        tripInformationOptions: {
          ...state.tripInformationOptions,
          unitDispositionOptions: action.unitDispositionOptions,
        },
      }
    case OptionsConstants.SET_PATIENT_EVALUATION_OPTIONS:
      return {
        ...state,
        tripInformationOptions: {
          ...state.tripInformationOptions,
          patientEvaluationOptions: action.patientEvaluationOptions,
        },
      }
    case OptionsConstants.SET_CREW_DISPOSITION_OPTIONS:
      return {
        ...state,
        tripInformationOptions: {
          ...state.tripInformationOptions,
          crewDispositionOptions: action.crewDispositionOptions,
        },
      }
    case OptionsConstants.SET_TRANSPORT_DISPOSITION_OPTIONS:
      return {
        ...state,
        tripInformationOptions: {
          ...state.tripInformationOptions,
          transportDispositionOptions: action.transportDispositionOptions,
        },
      }
    case OptionsConstants.SET_REFUSAL_RELEASE_REASON_OPTIONS:
      return {
        ...state,
        tripInformationOptions: {
          ...state.tripInformationOptions,
          refusalReleaseReasonOptions: action.refusalReleaseReasonOptions,
        },
      }
    case OptionsConstants.SET_AMBULANCE_TRANSPORT_CODE_OPTIONS:
      return {
        ...state,
        tripInformationOptions: {
          ...state.tripInformationOptions,
          ambulanceTransportCodeOptions: action.ambulanceTransportCodeOptions,
        },
      }
    case OptionsConstants.SET_MASS_CASUALTY_OPTIONS:
      return {
        ...state,
        tripInformationOptions: {
          ...state.tripInformationOptions,
          massCasualtyOptions: action.massCasualtyOptions,
        },
      }
    case OptionsConstants.SET_VEHICLE_GRID_OPTIONS:
      return {
        ...state,
        tripInformationOptions: {
          ...state.tripInformationOptions,
          vehicleGridOptions: action.vehicleGridOptions,
        },
      }
    case OptionsConstants.SET_EMS_VEHICLE_OPTIONS:
      return {
        ...state,
        tripInformationOptions: {
          ...state.tripInformationOptions,
          emsVehicleOptions: action.emsVehicleOptions,
        },
      }
    case OptionsConstants.SET_EMS_REG_TAIL_NUMBER_OPTIONS:
      return {
        ...state,
        tripInformationOptions: {
          ...state.tripInformationOptions,
          emsRegTailNumberOptions: action.emsRegTailNumberOptions,
        },
      }
    case OptionsConstants.SET_CHUNKED_PATIENT_ALLERGIES:
      return {
        ...state,
        patientAllergiesOptions: {
          ...state.patientAllergiesOptions,
          chunkedPatientAllergyOptions: [
            ...state.patientAllergiesOptions.chunkedPatientAllergyOptions,
            ...action.chunkedPatientAllergyOptions,
          ],
        },
      }
    case OptionsConstants.SET_TRANSFORMED_CHUNKED_PATIENT_ALLERGIES:
      return {
        ...state,
        patientAllergiesOptions: {
          ...state.patientAllergiesOptions,
          transformedChunkedPatientAllergyOptions: action.transformedChunkedPatientAllergyOptions,
        },
      }
    case OptionsConstants.SET_LOCATION_TYPE_OPTIONS:
      return {
        ...state,
        pickupAddressOptions: { ...state.pickupAddressOptions, locationTypeOptions: action.locationTypeOptions },
      }
    case OptionsConstants.SET_OTHER_TYPE_OPTIONS:
      return {
        ...state,
        pickupAddressOptions: { ...state.pickupAddressOptions, otherTypeOptions: action.otherTypeOptions },
      }
    case OptionsConstants.SET_HOSPITAL_UNIT_OPTIONS:
      return {
        ...state,
        pickupAddressOptions: { ...state.pickupAddressOptions, hospitalUnitOptions: action.hospitalUnitOptions },
      }
    case OptionsConstants.SET_HOSPITAL_NAME_OPTIONS:
      return {
        ...state,
        pickupAddressOptions: { ...state.pickupAddressOptions, hospitalNameOptions: action.hospitalNameOptions },
      }
    case OptionsConstants.SET_EMS_NAME_OPTIONS:
      return {
        ...state,
        pickupAddressOptions: { ...state.pickupAddressOptions, emsNameOptions: action.emsNameOptions },
      }
    case OptionsConstants.SET_DESTINATION_HOSPITAL_OPTIONS:
      return {
        ...state,
        destinationAddressOptions: { ...state.destinationAddressOptions, hospitalOptions: action.hospitalOptions },
      }
    case OptionsConstants.SET_DESTINATION_EMS_OPTIONS:
      return {
        ...state,
        destinationAddressOptions: { ...state.destinationAddressOptions, emsOptions: action.emsOptions },
      }
    case OptionsConstants.SET_DESTINATION_TRANSPORT_MODE_OPTIONS:
      return {
        ...state,
        destinationAddressOptions: {
          ...state.destinationAddressOptions,
          transportModeOptions: action.transportModeOptions,
        },
      }
    case OptionsConstants.SET_DESTINATION_TRANSPORT_MODE_CUSTOM_OPTIONS:
      return {
        ...state,
        destinationAddressOptions: {
          ...state.destinationAddressOptions,
          transportModeCustomOptions: action.transportModeCustomOptions,
        },
      }
    case OptionsConstants.SET_SCENE_GRID_OPTIONS:
      return {
        ...state,
        pickupAddressOptions: { ...state.pickupAddressOptions, sceneGridOptions: action.sceneGridOptions },
      }
    case OptionsConstants.SET_COMMON_ADDRESSES_OPTIONS:
      return {
        ...state,
        pickupAddressOptions: { ...state.pickupAddressOptions, commonAddressesOptions: action.commonAddressesOptions },
      }
    case OptionsConstants.SET_DESTINATION_BASIS_OPTIONS:
      return {
        ...state,
        destinationAddressOptions: {
          ...state.destinationAddressOptions,
          destinationBasisOptions: action.destinationBasisOptions,
        },
      }
    case OptionsConstants.SET_DESTINATION_MODE_DESCRIPTORS_OPTIONS:
      return {
        ...state,
        destinationAddressOptions: {
          ...state.destinationAddressOptions,
          modeDescriptorsOptions: action.modeDescriptorsOptions,
        },
      }
    case OptionsConstants.SET_CAPABILITIES_OPTIONS:
      return {
        ...state,
        destinationAddressOptions: {
          ...state.destinationAddressOptions,
          capabilities: action.capabilities,
        },
      }
    case OptionsConstants.SET_MODE_DESCRIPTORS_OPTIONS:
      return {
        ...state,
        pickupAddressOptions: { ...state.pickupAddressOptions, modeDescriptorsOptions: action.modeDescriptorsOptions },
      }
    case OptionsConstants.SET_RESPONSE_MODE_OPTIONS:
      return {
        ...state,
        pickupAddressOptions: { ...state.pickupAddressOptions, responseModeOptions: action.responseModeOptions },
      }
    case OptionsConstants.SET_RESPONSE_MODE_CUSTOM_OPTIONS:
      return {
        ...state,
        pickupAddressOptions: {
          ...state.pickupAddressOptions,
          responseModeCustomOptions: action.responseModeCustomOptions,
        },
      }
    case OptionsConstants.SET_AIRWAY_ACTION_OPTIONS:
      return {
        ...state,
        airwayOptions: { ...state.airwayOptions, actionOptions: action.actionOptions },
      }
    case OptionsConstants.SET_AIRWAY_VIA_OPTIONS:
      return {
        ...state,
        airwayOptions: { ...state.airwayOptions, viaOptions: action.viaOptions },
      }
    case OptionsConstants.SET_AIRWAY_VERIFICATION_METHOD_OPTIONS:
      return {
        ...state,
        airwayOptions: { ...state.airwayOptions, verificationMethodOptions: action.verificationMethodOptions },
      }
    case OptionsConstants.SET_AIRWAY_COMP_OPTIONS:
      return {
        ...state,
        airwayOptions: { ...state.airwayOptions, airwayComplicationsOptions: action.airwayComplicationsOptions },
      }
    case OptionsConstants.SET_CHILDBIRTHOB_ACTION_OPTIONS:
      return {
        ...state,
        childbirthOBOptions: { ...state.childbirthOBOptions, actionOptions: action.actionOptions },
      }
    case OptionsConstants.SET_VARIABILITY_OPTIONS:
      return {
        ...state,
        childbirthOBOptions: { ...state.childbirthOBOptions, variabilityOptions: action.variabilityOptions },
      }
    case OptionsConstants.SET_ACCELERATIONS_OPTIONS:
      return {
        ...state,
        childbirthOBOptions: { ...state.childbirthOBOptions, accelerationsOptions: action.accelerationsOptions },
      }
    case OptionsConstants.SET_DECELERATION_OPTIONS:
      return {
        ...state,
        childbirthOBOptions: { ...state.childbirthOBOptions, decelerationOptions: action.decelerationOptions },
      }
    case OptionsConstants.SET_UC_STRENGTH_OPTIONS:
      return {
        ...state,
        childbirthOBOptions: { ...state.childbirthOBOptions, ucStrengthOptions: action.ucStrengthOptions },
      }
    case OptionsConstants.SET_DTR_OPTIONS:
      return {
        ...state,
        childbirthOBOptions: { ...state.childbirthOBOptions, dtrOptions: action.dtrOptions },
      }
    case OptionsConstants.SET_IV_SITE_OPTIONS:
      return {
        ...state,
        initiateIvOptions: { ...state.initiateIvOptions, siteOptions: action.siteOptions },
      }
    case OptionsConstants.SET_IV_TYPE_OPTIONS:
      return {
        ...state,
        initiateIvOptions: { ...state.initiateIvOptions, typeOptions: action.typeOptions },
      }
    case OptionsConstants.SET_IMMOBILIZATION_ASSESSMENT_OPTIONS:
      return {
        ...state,
        immobilizationOptions: { ...state.immobilizationOptions, assessmentOptions: action.assessmentOptions },
      }
    case OptionsConstants.SET_IMMOBILIZATION_DEVICES_USED_OPTIONS:
      return {
        ...state,
        immobilizationOptions: { ...state.immobilizationOptions, devicesUsedOptions: action.devicesUsedOptions },
      }
    case OptionsConstants.SET_IMMOBILIZATION_OPTION_OPTIONS:
      return {
        ...state,
        immobilizationOptions: { ...state.immobilizationOptions, optionOptions: action.optionOptions },
      }
    case OptionsConstants.SET_IMMOBILIZATION_SITE_OPTIONS:
      return {
        ...state,
        immobilizationOptions: { ...state.immobilizationOptions, siteOptions: action.siteOptions },
      }
    case OptionsConstants.SET_PHYSICIAN_OPTIONS:
      return {
        ...state,
        medicalConsultOptions: { ...state.medicalConsultOptions, physicianOptions: action.physicianOptions },
      }
    case OptionsConstants.SET_MEDICAL_CONSULT_METHOD_OPTIONS:
      return {
        ...state,
        medicalConsultOptions: { ...state.medicalConsultOptions, methodOptions: action.methodOptions },
      }
    case OptionsConstants.SET_MEDICAL_CONSULT_FACILITY_OPTIONS:
      return {
        ...state,
        medicalConsultOptions: { ...state.medicalConsultOptions, facilityOptions: action.facilityOptions },
      }
    case OptionsConstants.SET_RESCUE_TYPES_OPTIONS:
      return {
        ...state,
        rescueOptions: { ...state.rescueOptions, typesOptions: action.typesOptions },
      }
    case OptionsConstants.SET_HYDRAULICS_OPTIONS:
      return {
        ...state,
        rescueOptions: { ...state.rescueOptions, hydraulicsOptions: action.hydraulicsOptions },
      }
    case OptionsConstants.SET_TOOLS_OPTIONS:
      return {
        ...state,
        rescueOptions: { ...state.rescueOptions, toolsOptions: action.toolsOptions },
      }
    case OptionsConstants.SET_REHAB_OPTIONS:
      return {
        ...state,
        rescueOptions: { ...state.rescueOptions, rehabOptions: action.rehabOptions },
      }
    case OptionsConstants.SET_ACTIVATIONS_OPTIONS:
      return {
        ...state,
        rescueOptions: { ...state.rescueOptions, activationsOptions: action.activationsOptions },
      }
    case OptionsConstants.SET_HOSPITAL_NOTIFY_ALERT_OPTIONS:
      return {
        ...state,
        hospitalNotifyOptions: { ...state.hospitalNotifyOptions, alertOptions: action.alertOptions },
      }
    case OptionsConstants.SET_HOSPITAL_NOTIFY_METHOD_OPTIONS:
      return {
        ...state,
        hospitalNotifyOptions: { ...state.hospitalNotifyOptions, methodOptions: action.methodOptions },
      }
    case OptionsConstants.SET_POTENTIAL_REGISTRY_OPTIONS:
      return {
        ...state,
        hospitalNotifyOptions: {
          ...state.hospitalNotifyOptions,
          potentialRegistryOptions: action.potentialRegistryOptions,
        },
      }
    case OptionsConstants.SET_WOUND_CARE_SITE_OPTIONS:
      return {
        ...state,
        woundCareOptions: { ...state.woundCareOptions, siteOptions: action.siteOptions },
      }
    case OptionsConstants.SET_WOUND_CARE_ACTIONS_OPTIONS:
      return {
        ...state,
        woundCareOptions: { ...state.woundCareOptions, actionsOptions: action.actionsOptions },
      }
    case OptionsConstants.SET_BREATH_TYPE_OPTIONS:
      return {
        ...state,
        ventilatorOptions: { ...state.ventilatorOptions, breathTypeOptions: action.breathTypeOptions },
      }
    case OptionsConstants.SET_VENTILATOR_PREVSTATE:
      return {
        ...state,
        ventilatorOptions: { ...state.ventilatorOptions, previousVentilatorState: action.previousVentilatorState },
      }
    case OptionsConstants.SET_VENTILATOR_ACTIONS_OPTIONS:
      return {
        ...state,
        ventilatorOptions: {
          ...state.ventilatorOptions,
          actionOptions: action.actionOptions,
        },
      }
    case OptionsConstants.SET_VENTILATOR_TEMPERTURE_UNIT_OPTIONS:
      return {
        ...state,
        ventilatorOptions: {
          ...state.ventilatorOptions,
          airTemperatureUnitOptions: action.airTemperatureUnitOptions,
        },
      }
    case OptionsConstants.SET_MODE_OPTIONS:
      return {
        ...state,
        ventilatorOptions: { ...state.ventilatorOptions, modeOptions: action.modeOptions },
      }
    case OptionsConstants.SET_SECTION_OPTIONS:
      return {
        ...state,
        signatureOptions: { ...state.signatureOptions, sectionOptions: action.sectionOptions },
      }
    case OptionsConstants.SET_SIGNATURE_TYPE_OPTIONS:
      return {
        ...state,
        signatureOptions: { ...state.signatureOptions, signatureTypeOptions: action.signatureTypeOptions },
      }
    case OptionsConstants.SET_SIGNATURE_SEC_TWO_PATIENT_UNABLE_TO_SIGN_OPTIONS:
      return {
        ...state,
        signatureOptions: {
          ...state.signatureOptions,
          signatureSecTwoPatientUnableToSignOptions: action.signatureSecTwoPatientUnableToSignOptions,
        },
      }
    case OptionsConstants.SET_SECTION_ONE_TYPES:
      return {
        ...state,
        signatureOptions: { ...state.signatureOptions, sectionOneSignatureTypes: action.sectionOneSignatureTypes },
      }
    case OptionsConstants.SET_SECTION_TWO_TYPES:
      return {
        ...state,
        signatureOptions: { ...state.signatureOptions, sectionTwoSignatureTypes: action.sectionTwoSignatureTypes },
      }
    case OptionsConstants.SET_SECTION_THREE_TYPES:
      return {
        ...state,
        signatureOptions: { ...state.signatureOptions, sectionThreeSignatureTypes: action.sectionThreeSignatureTypes },
      }
    case OptionsConstants.SET_SELECTED_CREW_MEMBERS:
      return {
        ...state,
        signatureOptions: { ...state.signatureOptions, selectedCrewMembers: action.selectedCrewMembers },
      }
    case OptionsConstants.SET_NIH_POSITIVE_STROKE_SCALE_QUESTION_ANSWERS:
      return {
        ...state,
        vitalOptions: {
          ...state.vitalOptions,
          nihPositiveStrokeScaleQuestionAnswers: action.nihPositiveStrokeScaleQuestionAnswers,
        },
      }
    case OptionsConstants.SET_RACE_STROKE_SCALE_QUESTION_ANSWERS:
      return {
        ...state,
        vitalOptions: { ...state.vitalOptions, raceStrokeScaleQuestionAnswers: action.raceStrokeScaleQuestionAnswers },
      }
    case OptionsConstants.SET_MEDICATIONS_ALLERGIES:
      return {
        ...state,
        patientAllergiesOptions: {
          ...state.patientAllergiesOptions,
          medicationsAllergiesOptions: action.medicationsAllergiesOptions,
        },
      }
    case OptionsConstants.SET_FOOD_ENVIRONMENTAL_ALLERGIES:
      return {
        ...state,
        patientAllergiesOptions: {
          ...state.patientAllergiesOptions,
          foodEnvironmentalAllergiesOptions: action.foodEnvironmentalAllergiesOptions,
        },
      }
    case OptionsConstants.SET_FORM_TEXT:
      return {
        ...state,
        signatureOptions: {
          ...state.signatureOptions,
          headerText: action.headerText,
          acknowledgmentText: action.acknowledgmentText,
          sectionIText: action.sectionIText,
          sectionIIText: action.sectionIIText,
          sectionIIIText: action.sectionIIIText,
          isStandardSignatureConfigured: true,
        },
      }
    case OptionsConstants.RESET_FORM_TEXT:
      return {
        ...state,
        signatureOptions: {
          ...state.signatureOptions,
          headerText: '',
          acknowledgmentText: '',
          sectionIText: '',
          sectionIIText: '',
          sectionIIIText: '',
          isStandardSignatureConfigured: false,
        },
      }
    case OptionsConstants.SET_SERVICE_MODULES:
      return {
        ...state,
        configurationOptions: { ...state.configurationOptions, serviceModules: action.serviceModules },
      }
    case OptionsConstants.SET_TIME_ZONE_OPTIONS:
      return {
        ...state,
        configurationOptions: { ...state.configurationOptions, timeZoneOptions: action.timeZoneOptions },
      }
    case OptionsConstants.SET_CAD_RECORDS:
      return {
        ...state,
        cadImportOptions: { ...state.cadImportOptions, data: action.data },
      }
    case OptionsConstants.RESET_CAD_RECORDS:
      return {
        ...state,
        cadImportOptions: { ...state.cadImportOptions, data: [] },
      }
    case OptionsConstants.SET_PHONE: {
      return {
        ...state,
        patientDemographicsOptions: {
          ...state.patientDemographicsOptions,
          number: action.number,
          phoneDetail: action.phoneDetail,
        },
      }
    }
    case OptionsConstants.SET_PHONE_TYPE:
      return {
        ...state,
        patientDemographicsOptions: {
          ...state.patientDemographicsOptions,
          phoneType: action.phoneType,
          phoneDetail: action.phoneDetail,
        },
      }
    case OptionsConstants.DELETE_PHONE:
      return {
        ...state,
        patientDemographicsOptions: {
          ...state.patientDemographicsOptions,
          phoneDetail: action.phoneDetail,
        },
      }
    case OptionsConstants.SET_EMAIL:
      return {
        ...state,
        patientDemographicsOptions: {
          ...state.patientDemographicsOptions,
          email: action.email,
          emailDetail: action.emailDetail,
        },
      }
    case OptionsConstants.SET_EMAIL_TYPE:
      return {
        ...state,
        patientDemographicsOptions: {
          ...state.patientDemographicsOptions,
          emailType: action.emailType,
          emailDetail: action.emailDetail,
        },
      }
    case OptionsConstants.DELETE_EMAIL:
      return {
        ...state,
        patientDemographicsOptions: {
          ...state.patientDemographicsOptions,
          emailDetail: action.emailDetail,
        },
      }
    case OptionsConstants.SET_INITIAL_PATIENT_ACUITY_OPTIONS:
      return {
        ...state,
        ccHpiOptions: { ...state.ccHpiOptions, initialPatientAcuityOptions: action.initialPatientAcuityOptions },
      }
    case OptionsConstants.SET_ALS_ASSESSMENT_OPTIONS:
      return {
        ...state,
        ccHpiOptions: { ...state.ccHpiOptions, alsAssessmentOptions: action.alsAssessmentOptions },
      }
    case OptionsConstants.SET_PATIENT_ACTIVITY_OPTIONS:
      return {
        ...state,
        ccHpiOptions: { ...state.ccHpiOptions, patientActivityOptions: action.patientActivityOptions },
      }
    case OptionsConstants.SET_REASON_FOR_ENCOUNTER_OPTIONS:
      return {
        ...state,
        ccHpiOptions: { ...state.ccHpiOptions, reasonForEncounterOptions: action.reasonForEncounterOptions },
      }
    case OptionsConstants.SET_DRUGS_AND_ALCOHOL_OPTIONS:
      return {
        ...state,
        ccHpiOptions: { ...state.ccHpiOptions, drugsAndAlcoholOptions: action.drugsAndAlcoholOptions },
      }
    case OptionsConstants.SET_DRUGS_AND_ALCOHOL_INDICATORS_OPTIONS:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          drugsAndAlcoholIndicatorsOptions: action.drugsAndAlcoholIndicatorsOptions,
        },
      }
    case OptionsConstants.SET_ARREST_PRESENT:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          arrestPresentOptions: action.arrestPresentOptions,
        },
      }
    case OptionsConstants.SET_INTENTIONAL_OPTIONS:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          intentionalOptions: action.intentionalOptions,
        },
      }
    case OptionsConstants.SET_WHO_WITNESSED:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          whoWitnessedOptions: action.whoWitnessedOptions,
        },
      }
    case OptionsConstants.SET_TRAUMA_TRIAGE_CRITERIA_HIGH_RISK_OPTIONS:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          traumaTriageCriteriaHighRiskOptions: action.traumaTriageCriteriaHighRiskOptions,
        },
      }
    case OptionsConstants.SET_ETIOLOGY:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          etiologyOptions: action.etiologyOptions,
        },
      }
    case OptionsConstants.SET_TRAUMA_TRIAGE_CRITERIA_MODERATE_RISK_OPTIONS:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          traumaTriageCriteriaModerateRiskOptions: action.traumaTriageCriteriaModerateRiskOptions,
        },
      }
    case OptionsConstants.SET_THERAPEUTIC_HYPOTHERMIA:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          therapeuticHypothermiaOptions: action.therapeuticHypothermiaOptions,
        },
      }
    case OptionsConstants.SET_INJURY_CAUSE_OPTIONS:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          injurycauseOptions: action.injurycauseOptions,
        },
      }
    case OptionsConstants.SET_INITIAL_RHYTHM:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          initialRhythmOptions: action.initialRhythmOptions,
        },
      }
    case OptionsConstants.SET_MECHANISM_OPTIONS:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          mechanismOptions: action.mechanismOptions,
        },
      }
    case OptionsConstants.SET_CPR_PRIOR_EMS_ARRIVAL:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          cprPriorEmsArrivalOptions: action.cprPriorEmsArrivalOptions,
        },
      }
    case OptionsConstants.SET_SAFETY_EQUIPMENT_OPTIONS:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          safetyEquipmentOptions: action.safetyEquipmentOptions,
        },
      }
    case OptionsConstants.SET_FIRST_CPR:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          firstCprOptions: action.firstCprOptions,
        },
      }
    case OptionsConstants.SET_FALL_SURFACE_OPTIONS:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          fallsurfaceOptions: action.fallsurfaceOptions,
        },
      }

    case OptionsConstants.SET_CPR_BY:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          cprByOptions: action.cprByOptions,
        },
      }
    case OptionsConstants.SET_LANDED_ON_OPTIONS:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          landedonOptions: action.landedonOptions,
        },
      }
    case OptionsConstants.SET_CPR_TYPE:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          cprTypeOptions: action.cprTypeOptions,
        },
      }
    case OptionsConstants.SET_WORK_RELATED_OPTIONS:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          workrelatedOptions: action.workrelatedOptions,
        },
      }
    case OptionsConstants.SET_CC_DURATION_UNITS_OPTIONS:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          ccDurationUnitsOptions: action.ccDurationUnitsOptions,
        },
      }
    case OptionsConstants.SET_SC_DURATION_UNITS_OPTIONS:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          scDurationUnitsOptions: action.scDurationUnitsOptions,
        },
      }
    case OptionsConstants.SET_OC_DURATION_UNITS_OPTIONS:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          ocDurationUnitsOptions: action.ocDurationUnitsOptions,
        },
      }
    case OptionsConstants.SET_AIRBAG_DEPLOYED_OPTIONS:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          airbagDeployedOptions: action.airbagDeployedOptions,
        },
      }
    case OptionsConstants.SET_VEHICLE_IMPACT_SITE_OPTIONS:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          vehicleImpactSiteOptions: action.vehicleImpactSiteOptions,
        },
      }
    case OptionsConstants.SET_LOCATION_OF_PATIENT_IN_VEHICLE_OPTIONS:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          locationOfPatientInVehicleOptions: action.locationOfPatientInVehicleOptions,
        },
      }
    case OptionsConstants.SET_EXTRICATION_REQUIRED_OPTIONS:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          extricationRequiredOptions: action.extricationRequiredOptions,
        },
      }
    case OptionsConstants.SET_RESUSCITATION:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          resuscitationOptions: action.resuscitationOptions,
        },
      }
    case OptionsConstants.SET_AED_USE:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          aedUseOptions: action.aedUseOptions,
        },
      }
    case OptionsConstants.SET_FIRST_AED_BY:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          firstAedByOptions: action.firstAedByOptions,
        },
      }
    case OptionsConstants.SET_AED_BY:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          aedByOptions: action.aedByOptions,
        },
      }
    case OptionsConstants.SET_DEFIB_TYPE:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          defibTypeOptions: action.defibTypeOptions,
        },
      }
    case OptionsConstants.SET_DEFIB_BY:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          defibByOptions: action.defibByOptions,
        },
      }
    case OptionsConstants.SET_DISC_REASON:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          discReasonOptions: action.discReasonOptions,
        },
      }
    case OptionsConstants.SET_RETURN_CIRCULATION:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          returnCirculationOptions: action.returnCirculationOptions,
        },
      }
    case OptionsConstants.SET_DEST_RHYTHM:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          destRhythmOptions: action.destRhythmOptions,
        },
      }
    case OptionsConstants.SET_ARREST_RESULT:
      return {
        ...state,
        ccHpiOptions: {
          ...state.ccHpiOptions,
          arrestResultOptions: action.arrestResultOptions,
        },
      }
    case OptionsConstants.SET_DT_WITNESSED_PNNV_OPTIONS:
      return {
        ...state,
        ccHpiOptions: { ...state.ccHpiOptions, dtWitnessedPNNVOptions: action.dtWitnessedPNNVOptions },
      }
    case OptionsConstants.SET_PRIORITY_OPTIONS:
      return {
        ...state,
        insuranceInformationOptions: { ...state.insuranceInformationOptions, priorityOptions: action.priorityOptions },
      }
    case OptionsConstants.SET_INSURED_OPTIONS:
      return {
        ...state,
        insuranceInformationOptions: { ...state.insuranceInformationOptions, insuredOptions: action.insuredOptions },
      }
    case OptionsConstants.RESET_INSURED_OPTIONS:
      return {
        ...state,
        insuranceInformationOptions: { ...state.insuranceInformationOptions, insuredOptions: [patientInsuredOption] },
      }
    case OptionsConstants.SET_RELATIONSHIP_OPTIONS:
      return {
        ...state,
        relationshipsAndGuarantorsOptions: {
          ...state.relationshipsAndGuarantorsOptions,
          relationshipOptions: action.relationshipOptions,
        },
      }
    case OptionsConstants.SET_CMS_CONDITION_CODE_OPTIONS:
      return {
        ...state,
        cmsInformationOptions: {
          ...state.cmsInformationOptions,
          cmsConditionCodeOptions: action.cmsConditionCodeOptions,
        },
      }
    case OptionsConstants.SET_FILTER_CMS_CONDITION_CODE_OPTIONS:
      return {
        ...state,
        cmsInformationOptions: {
          ...state.cmsInformationOptions,
          filteredCmsConditionCodeOptions: action.filteredCmsConditionCodeOptions,
        },
      }
    case OptionsConstants.SET_CONDITION_CODE_MODIFIER_OPTIONS:
      return {
        ...state,
        cmsInformationOptions: {
          ...state.cmsInformationOptions,
          conditionCodeModifierOptions: action.conditionCodeModifierOptions,
        },
      }
    case OptionsConstants.SET_CMS_TRANSPORT_REASON_OPTIONS:
      return {
        ...state,
        cmsInformationOptions: {
          ...state.cmsInformationOptions,
          cmsTransportReasonOptions: action.cmsTransportReasonOptions,
        },
      }
    case OptionsConstants.SET_AMBULANCE_CONDITION_INDICATOR_OPTIONS:
      return {
        ...state,
        cmsInformationOptions: {
          ...state.cmsInformationOptions,
          ambulanceConditionIndicatorOptions: action.ambulanceConditionIndicatorOptions,
        },
      }
    case OptionsConstants.SET_CONSENT_FORM_SIGNED_OPTIONS:
      return {
        ...state,
        pcsInformationOption: {
          ...state.pcsInformationOption,
          consentFormSignedOptions: action.consentFormSignedOptions,
        },
      }
    case OptionsConstants.SET_NPP_FORM_OPTIONS:
      return {
        ...state,
        pcsInformationOption: {
          ...state.pcsInformationOption,
          nppFormOptions: action.nppFormOptions,
        },
      }
    case OptionsConstants.SET_MEDICAL_NECESSITY_SIGNED_OPTIONS:
      return {
        ...state,
        pcsInformationOption: {
          ...state.pcsInformationOption,
          medicalNecessitySignedOptions: action.medicalNecessitySignedOptions,
        },
      }
    case OptionsConstants.SET_PCS_REASON_OPTIONS:
      return {
        ...state,
        pcsInformationOption: {
          ...state.pcsInformationOption,
          pcsReasonOptions: action.pcsReasonOptions,
        },
      }
    case OptionsConstants.SET_PCS_PROVIDER_TYPE_OPTIONS:
      return {
        ...state,
        pcsInformationOption: {
          ...state.pcsInformationOption,
          pcsProviderTypeOptions: action.pcsProviderTypeOptions,
        },
      }
    case OptionsConstants.SET_PRIMARY_PAYMENT_METHOD_OPTIONS:
      return {
        ...state,
        paymentInformationOptions: {
          ...state.paymentInformationOptions,
          primaryMethodOfPaymentOptions: action.primaryMethodOfPaymentOptions,
        },
      }
    case OptionsConstants.SET_X12_PAYER_TYPE_OPTIONS:
      return {
        ...state,
        paymentInformationOptions: {
          ...state.paymentInformationOptions,
          x12PayerTypeOptions: action.x12PayerTypeOptions,
        },
      }
    case OptionsConstants.SET_PRIOR_AUTHORIZATION_PAYER_OPTIONS:
      return {
        ...state,
        paymentInformationOptions: {
          ...state.paymentInformationOptions,
          priorAuthorizationPayerOptions: action.priorAuthorizationPayerOptions,
        },
      }
    case OptionsConstants.SET_CAMERA_ATTACHMENTS_CATEGORY_OPTIONS:
      return {
        ...state,
        cameraAttachmentsOptions: {
          ...state.cameraAttachmentsOptions,
          categoryOptions: action.categoryOptions,
        },
      }
    case OptionsConstants.SET_CUSTOM_SIGNATURE_OPTIONS:
      return {
        ...state,
        signatureOptions: { ...state.signatureOptions, customSignatureOptions: action.customSignatureOptions },
      }
    case OptionsConstants.SET_CUSTOM_SIGNATURE_TYPE_OPTIONS:
      return {
        ...state,
        signatureOptions: { ...state.signatureOptions, customSignatureTypeOptions: action.customSignatureTypeOptions },
      }
    case OptionsConstants.SET_SECTION_TWO_AUTHORIZED_REPRESENTATIVE_OPTIONS:
      return {
        ...state,
        signatureOptions: {
          ...state.signatureOptions,
          sectionTwoAuthorizedRepresentativeOptions: action.sectionTwoAuthorizedRepresentativeOptions,
        },
      }
    case OptionsConstants.SET_CUSTOM_SIGNATURE_TRANSFORMED_OPTIONS:
      return {
        ...state,
        signatureOptions: {
          ...state.signatureOptions,
          customSignatureTranformedOptions: action.customSignatureTranformedOptions,
        },
      }
    case OptionsConstants.SET_DISPATCH_FACTORS_OPTIONS:
      return {
        ...state,
        factorsAffectingCareOptions: {
          ...state.factorsAffectingCareOptions,
          dispatchFactorsOptions: action.dispatchFactorsOptions,
        },
      }
    case OptionsConstants.SET_RESPONSE_FACTORS_OPTIONS:
      return {
        ...state,
        factorsAffectingCareOptions: {
          ...state.factorsAffectingCareOptions,
          responseFactorsOptions: action.responseFactorsOptions,
        },
      }
    case OptionsConstants.SET_SCENE_FACTORS_OPTIONS:
      return {
        ...state,
        factorsAffectingCareOptions: {
          ...state.factorsAffectingCareOptions,
          sceneFactorsOptions: action.sceneFactorsOptions,
        },
      }
    case OptionsConstants.SET_TRANSPORT_FACTORS_OPTIONS:
      return {
        ...state,
        factorsAffectingCareOptions: {
          ...state.factorsAffectingCareOptions,
          transportFactorsOptions: action.transportFactorsOptions,
        },
      }
    case OptionsConstants.SET_TURN_AROUND_FACTORS_OPTIONS:
      return {
        ...state,
        factorsAffectingCareOptions: {
          ...state.factorsAffectingCareOptions,
          turnAroundFactorsOptions: action.turnAroundFactorsOptions,
        },
      }
    case OptionsConstants.SET_FACTORS_OPTIONS:
      return {
        ...state,
        factorsAffectingCareOptions: {
          ...state.factorsAffectingCareOptions,
          factorsOptions: action.factorsOptions,
        },
      }
    case OptionsConstants.SET_FIRST_ON_SCENE_OPTIONS:
      return {
        ...state,
        sceneDescriptionOptions: {
          ...state.sceneDescriptionOptions,
          firstOnSceneOptions: action.firstOnSceneOptions,
        },
      }
    case OptionsConstants.SET_LEVEL_CARE_PER_PROTOCOL_OPTIONS:
      return {
        ...state,
        sceneDescriptionOptions: {
          ...state.sceneDescriptionOptions,
          levelCarePerProtocolOptions: action.levelCarePerProtocolOptions,
        },
      }
    case OptionsConstants.SET_PN_MEDICATION_MEDICATION_OPTIONS:
      return {
        ...state,
        pnMedicationOptions: {
          ...state.pnMedicationOptions,
          medicationOptions: action.medicationOptions,
        },
      }
    case OptionsConstants.SET_PR_OTHER_AGENCIES_OPTIONS:
      return {
        ...state,
        sceneDescriptionOptions: {
          ...state.sceneDescriptionOptions,
          prOtherAgenciesOptions: action.prOtherAgenciesOptions,
        },
      }
    case OptionsConstants.SET_TRANSFER_OF_CARE_OPTIONS:
      return {
        ...state,
        sceneDescriptionOptions: {
          ...state.sceneDescriptionOptions,
          transferOfCareOptions: action.transferOfCareOptions,
        },
      }
    case OptionsConstants.SET_PR_DISASTER_OPTIONS:
      return {
        ...state,
        sceneDescriptionOptions: {
          ...state.sceneDescriptionOptions,
          prDisasterOptions: action.prDisasterOptions,
        },
      }
    case OptionsConstants.SET_PR_PT_MOVED_VIA_OPTIONS:
      return {
        ...state,
        sceneDescriptionOptions: {
          ...state.sceneDescriptionOptions,
          prPtMovedViaOptions: action.prPtMovedViaOptions,
        },
      }
    case OptionsConstants.SET_PR_PT_POSITION_OPTIONS:
      return {
        ...state,
        sceneDescriptionOptions: {
          ...state.sceneDescriptionOptions,
          prPtPositionOptions: action.prPtPositionOptions,
        },
      }
    case OptionsConstants.SET_PR_PT_MOVED_FROM_OPTIONS:
      return {
        ...state,
        sceneDescriptionOptions: {
          ...state.sceneDescriptionOptions,
          prPtMovedFromOptions: action.prPtMovedFromOptions,
        },
      }
    case OptionsConstants.SET_PR_TRANSPORT_ASSESS_OPTIONS:
      return {
        ...state,
        sceneDescriptionOptions: {
          ...state.sceneDescriptionOptions,
          prTransportAssessOptions: action.prTransportAssessOptions,
        },
      }
    case OptionsConstants.SET_PR_DISPO_INSTRUCTIONS_OPTIONS:
      return {
        ...state,
        sceneDescriptionOptions: {
          ...state.sceneDescriptionOptions,
          prDispoInstructionsOptions: action.prDispoInstructionsOptions,
        },
      }
    case OptionsConstants.SET_OTHER_AGENCY_NAME_OPTIONS:
      return {
        ...state,
        sceneDescriptionOptions: {
          ...state.sceneDescriptionOptions,
          otherAgencyNameOptions: action.otherAgencyNameOptions,
        },
      }
    case OptionsConstants.SET_OTHER_AGENCY_TYPE_OPTIONS:
      return {
        ...state,
        sceneDescriptionOptions: {
          ...state.sceneDescriptionOptions,
          otherAgencyTypeOptions: action.otherAgencyTypeOptions,
        },
      }
    case OptionsConstants.SET_AIR_STATUS_OPTIONS:
      return {
        ...state,
        assessmentAirwayOptions: {
          ...state.assessmentAirwayOptions,
          airStatusOptions: action.airStatusOptions,
        },
      }
    case OptionsConstants.SET_AIR_TYPE_OPTIONS:
      return {
        ...state,
        assessmentAirwayOptions: {
          ...state.assessmentAirwayOptions,
          airTypeOptions: action.airTypeOptions,
        },
      }
    case OptionsConstants.SET_AIR_ETT_SIZE_UNIT_OPTIONS:
      return {
        ...state,
        assessmentAirwayOptions: {
          ...state.assessmentAirwayOptions,
          airEttSizeUnitOptions: action.airEttSizeUnitOptions,
        },
      }
    case OptionsConstants.SET_AIR_BY_OPTIONS:
      return {
        ...state,
        assessmentAirwayOptions: {
          ...state.assessmentAirwayOptions,
          airByOptions: action.airByOptions,
        },
      }
    case OptionsConstants.SET_AIR_OUTCOME_OPTIONS:
      return {
        ...state,
        assessmentAirwayOptions: {
          ...state.assessmentAirwayOptions,
          airOutcomeOptions: action.airOutcomeOptions,
        },
      }
    case OptionsConstants.SET_AIRWAY_VERIFICATION_ASSESS_OPTIONS:
      return {
        ...state,
        assessmentAirwayOptions: {
          ...state.assessmentAirwayOptions,
          prAirwayVerificationAssessOptions: action.prAirwayVerificationAssessOptions,
        },
      }
    case OptionsConstants.SET_AIRWAY_ASSESS_OPTIONS:
      return {
        ...state,
        assessmentAirwayOptions: {
          ...state.assessmentAirwayOptions,
          prAirwayAssessOptions: action.prAirwayAssessOptions,
        },
      }
    case OptionsConstants.SET_AIRWAY_BROSELOW_OPTIONS:
      return {
        ...state,
        assessmentAirwayOptions: {
          ...state.assessmentAirwayOptions,
          airBroselowOptions: action.airBroselowOptions,
        },
      }
    case OptionsConstants.SET_BREATH_SOUND_LEFT_OPTIONS:
      return {
        ...state,
        respiratoryOptions: {
          ...state.respiratoryOptions,
          breathSoundLeftOptions: action.breathSoundLeftOptions,
        },
      }
    case OptionsConstants.SET_BREATH_SOUND_RIGHT_OPTIONS:
      return {
        ...state,
        respiratoryOptions: {
          ...state.respiratoryOptions,
          breathSoundRightOptions: action.breathSoundRightOptions,
        },
      }
    case OptionsConstants.SET_RESP_EFFORT_OPTIONS:
      return {
        ...state,
        respiratoryOptions: {
          ...state.respiratoryOptions,
          respEffortOptions: action.respEffortOptions,
        },
      }
    case OptionsConstants.SET_RESP_VIA_OPTIONS:
      return {
        ...state,
        respiratoryOptions: {
          ...state.respiratoryOptions,
          respViaOptions: action.respViaOptions,
        },
      }
    case OptionsConstants.SET_RESP_PERFORM_BY_OPTIONS:
      return {
        ...state,
        respiratoryOptions: {
          ...state.respiratoryOptions,
          respPerformByOptions: action.respPerformByOptions,
        },
      }
    case OptionsConstants.SET_RESP_OUTCOME_OPTIONS:
      return {
        ...state,
        respiratoryOptions: {
          ...state.respiratoryOptions,
          respOutcomeOptions: action.respOutcomeOptions,
        },
      }
    case OptionsConstants.SET_RESP_EXAM_OPTIONS:
      return {
        ...state,
        respiratoryOptions: {
          ...state.respiratoryOptions,
          respExamOptions: action.respExamOptions,
        },
      }

    case OptionsConstants.SET_MOTOROPTIONS:
      return {
        ...state,
        neuroOptions: {
          ...state.neuroOptions,
          motorOptions: action.motorOptions,
        },
      }
    case OptionsConstants.SET_SENSORYOPTIONS:
      return {
        ...state,
        neuroOptions: {
          ...state.neuroOptions,
          sensoryOptions: action.sensoryOptions,
        },
      }
    case OptionsConstants.SET_PUPILSSIZEOPTIONS:
      return {
        ...state,
        neuroOptions: {
          ...state.neuroOptions,
          pupilsSizeOptions: action.pupilsSizeOptions,
        },
      }
    case OptionsConstants.SET_PUPILSREACTOPTIONS:
      return {
        ...state,
        neuroOptions: {
          ...state.neuroOptions,
          pupilsReactOptions: action.pupilsReactOptions,
        },
      }
    case OptionsConstants.SET_HEADCONCIOUSNESSOPTIONS:
      return {
        ...state,
        neuroOptions: {
          ...state.neuroOptions,
          headConciousnessOptions: action.headConciousnessOptions,
        },
      }
    case OptionsConstants.SET_THROMSCREENOPTIONS:
      return {
        ...state,
        neuroOptions: {
          ...state.neuroOptions,
          thromScreenOptions: action.thromScreenOptions,
        },
      }
    case OptionsConstants.SET_STROKESCALENEUROOPTIONS:
      return {
        ...state,
        neuroOptions: {
          ...state.neuroOptions,
          strokeScaleNeuroOptions: action.strokeScaleNeuroOptions,
        },
      }
    case OptionsConstants.SET_STROKECVASYMPTOMSRESOLVEDOPTIONS:
      return {
        ...state,
        neuroOptions: {
          ...state.neuroOptions,
          strokeCvaSymptomsResolvedOptions: action.strokeCvaSymptomsResolvedOptions,
        },
      }
    case OptionsConstants.SET_HEADLOSSCONSOPTIONS:
      return {
        ...state,
        neuroOptions: {
          ...state.neuroOptions,
          headLossConsOptions: action.headLossConsOptions,
        },
      }

    case OptionsConstants.SET_PTS_SIZE_OPTIONS:
      return {
        ...state,
        ptsOptions: {
          ...state.ptsOptions,
          ptsSizeOptions: action.ptsSizeOptions,
        },
      }
    case OptionsConstants.SET_PTS_AIR_OPTIONS:
      return {
        ...state,
        ptsOptions: {
          ...state.ptsOptions,
          ptsAirwayOptions: action.ptsAirwayOptions,
        },
      }
    case OptionsConstants.SET_PTS_BP_OPTIONS:
      return {
        ...state,
        ptsOptions: {
          ...state.ptsOptions,
          ptsBpOptions: action.ptsBpOptions,
        },
      }
    case OptionsConstants.SET_PTS_CNS_OPTIONS:
      return {
        ...state,
        ptsOptions: {
          ...state.ptsOptions,
          ptsCnsOptions: action.ptsCnsOptions,
        },
      }
    case OptionsConstants.SET_PTS_SKEL_OPTIONS:
      return {
        ...state,
        ptsOptions: {
          ...state.ptsOptions,
          ptsSkelOptions: action.ptsSkelOptions,
        },
      }
    case OptionsConstants.SET_PTS_WOUND_OPTIONS:
      return {
        ...state,
        ptsOptions: {
          ...state.ptsOptions,
          ptsWoundOptions: action.ptsWoundOptions,
        },
      }
    case OptionsConstants.SET_RTS_SYS_BP_OPTIONS:
      return {
        ...state,
        rtsOptions: {
          ...state.rtsOptions,
          rtsSysBpOptions: action.rtsSysBpOptions,
        },
      }
    case OptionsConstants.SET_RTS_RESP_RATE_OPTIONS:
      return {
        ...state,
        rtsOptions: {
          ...state.rtsOptions,
          rtsRespRateOptions: action.rtsRespRateOptions,
        },
      }
    case OptionsConstants.SET_PATIENT_WAS_IMMOBILIZED_PERFORMED_BY:
      return {
        ...state,
        wasPatientImmobilizedOptions: {
          ...state.wasPatientImmobilizedOptions,
          wasPatientImmobilizedPerformedByOptions: action.wasPatientImmobilizedPerformedByOptions,
        },
      }
    case OptionsConstants.SET_PATIENT_WAS_IMMOBILIZED_OUTCOME:
      return {
        ...state,
        wasPatientImmobilizedOptions: {
          ...state.wasPatientImmobilizedOptions,
          wasPatientImmobilizedOutcomeOptions: action.wasPatientImmobilizedOutcomeOptions,
        },
      }
    case OptionsConstants.SET_GCS_QUALIFIER:
      return {
        ...state,
        gcsOptions: {
          ...state.gcsOptions,
          gcsQualifierOptions: action.gcsQualifierOptions,
        },
      }
    case OptionsConstants.SET_GCS_EYE_RESPONSE:
      return {
        ...state,
        gcsOptions: {
          ...state.gcsOptions,
          gcsEyeResponseOptions: action.gcsEyeResponseOptions,
        },
      }
    case OptionsConstants.SET_GCS_VERBAL_RESPONSE:
      return {
        ...state,
        gcsOptions: {
          ...state.gcsOptions,
          gcsVerbalResponseOptions: action.gcsVerbalResponseOptions,
        },
      }
    case OptionsConstants.SET_GCS_MOTOR_RESPONSE:
      return {
        ...state,
        gcsOptions: {
          ...state.gcsOptions,
          gcsMotorResponseOptions: action.gcsMotorResponseOptions,
        },
      }
    case OptionsConstants.SET_PULSES_OPTIONS:
      return {
        ...state,
        cardioOptions: {
          ...state.cardioOptions,
          pulsesOptions: action.pulsesOptions,
        },
      }
    case OptionsConstants.SET_PR_CV_ASSESS_OPTIONS:
      return {
        ...state,
        cardioOptions: {
          ...state.cardioOptions,
          prCvAssessOptions: action.prCvAssessOptions,
        },
      }
    case OptionsConstants.SET_CV_TEMP_METHOD_OPTIONS:
      return {
        ...state,
        cardioOptions: {
          ...state.cardioOptions,
          cvTempMethodOptions: action.cvTempMethodOptions,
        },
      }
    case OptionsConstants.SET_CV_JVD_OPTIONS:
      return {
        ...state,
        cardioOptions: {
          ...state.cardioOptions,
          cvJvdOptions: action.cvJvdOptions,
        },
      }
    case OptionsConstants.SET_CV_CAP_REFILL_OPTIONS:
      return {
        ...state,
        cardioOptions: {
          ...state.cardioOptions,
          cvCapRefillOptions: action.cvCapRefillOptions,
        },
      }
    case OptionsConstants.SET_CV_EDEMA_OPTIONS:
      return {
        ...state,
        cardioOptions: {
          ...state.cardioOptions,
          cvEdemaOptions: action.cvEdemaOptions,
        },
      }
    case OptionsConstants.SET_CV_ART_OPTIONS:
      return {
        ...state,
        cardioOptions: {
          ...state.cardioOptions,
          cvArtOptions: action.cvArtOptions,
        },
      }
    case OptionsConstants.SET_CV_SWAN_OPTIONS:
      return {
        ...state,
        cardioOptions: {
          ...state.cardioOptions,
          cvSwanOptions: action.cvSwanOptions,
        },
      }
    case OptionsConstants.SET_PM_TYPE_OPTIONS:
      return {
        ...state,
        cardioOptions: {
          ...state.cardioOptions,
          pmTypeOptions: action.pmTypeOptions,
        },
      }
    case OptionsConstants.SET_NEURO_STROKE_SCALE_SCORE_OPTIONS:
      return {
        ...state,
        neuroOptions: {
          ...state.neuroOptions,
          strokeScaleScoreOptions: action.strokeScaleScoreOptions,
        },
      }

    case OptionsConstants.SET_STROKE_SCALE_CONFIG_OPTIONS: {
      return {
        ...state,
        neuroOptions: {
          ...state.neuroOptions,
          strokeScaleConfigOptions: action.strokeScaleConfigOptions ?? [],
        },
        vitalOptions: {
          ...state.vitalOptions,
          strokeScaleConfigOptions: action.strokeScaleConfigOptions ?? [],
        },
      }
    }

    case OptionsConstants.SET_NEURO_CUSTOM_STROKE_SCALE_SCORE_OPTIONS:
      return {
        ...state,
        neuroOptions: {
          ...state.neuroOptions,
          customStrokeScaleScoreOptions: action.customStrokeScaleScoreOptions,
        },
      }

    case OptionsConstants.SET_VITALS_CUSTOM_STROKE_SCALE_SCORE_OPTIONS:
      return {
        ...state,
        vitalOptions: {
          ...state.vitalOptions,
          customStrokeScaleScoreOptions: action.customStrokeScaleScoreOptions,
        },
      }
    case OptionsConstants.SET_LABS_CONFIG_OPTIONS:
      return {
        ...state,
        labsOptions: {
          ...state.labsOptions,
          labsConfigOptions: action.labsConfigOptions,
        },
      }
    case OptionsConstants.SET_ABG_ACCESS_OPTIONS:
      return {
        ...state,
        labsOptions: {
          ...state.labsOptions,
          abgAccessOptions: action.abgAccessOptions,
        },
      }
    case OptionsConstants.SET_PN_PROCEDURE_OPTIONS:
      return {
        ...state,
        pnProcedureOptions: {
          ...state.pnProcedureOptions,
          pertinentNegativeProcedureOptions: action.pertinentNegativeProcedureOptions,
        },
      }
    case OptionsConstants.SET_EXPOSURE_EQUIPMENT_OPTIONS:
      return {
        ...state,
        exposureOptions: {
          ...state.exposureOptions,
          exposureEquipmentOptions: action.exposureEquipmentOptions,
        },
      }
    case OptionsConstants.SET_EXPOSURE_TYPE_OPTIONS:
      return {
        ...state,
        exposureOptions: {
          ...state.exposureOptions,
          exposureTypeOptions: action.exposureTypeOptions,
        },
      }
    case OptionsConstants.SET_EXPOSED_TO_OPTIONS:
      return {
        ...state,
        exposureOptions: {
          ...state.exposureOptions,
          exposedToOptions: action.exposedToOptions,
        },
      }
    case OptionsConstants.SET_EXPOSURE_CREW:
      return {
        ...state,
        exposureOptions: {
          ...state.exposureOptions,
          exposureCrewOptions: action.exposureCrewOptions,
        },
      }
    case OptionsConstants.SET_SUSPECTED_EXPOSURE:
      return {
        ...state,
        exposureOptions: {
          ...state.exposureOptions,
          suspectedExposureOptions: action.suspectedExposureOptions,
        },
      }
    case OptionsConstants.SET_IMMUNIZATION_STATUS_OPTIONS:
      return {
        ...state,
        immunizationOptions: {
          ...state.immunizationOptions,
          immunizationStatusOptions: action.immunizationStatusOptions,
        },
      }
    case OptionsConstants.SET_IMMUNIZATION_TYPE_OPTIONS:
      return {
        ...state,
        immunizationOptions: {
          ...state.immunizationOptions,
          immunizationTypeOptions: action.immunizationTypeOptions,
        },
      }
    case OptionsConstants.SET_IMMUNIZATION_YEAR_OPTIONS:
      return {
        ...state,
        immunizationOptions: {
          ...state.immunizationOptions,
          immunizationYearOptions: action.immunizationYearOptions,
        },
      }
    case OptionsConstants.SET_RULES_OPTIONS:
      return {
        ...state,
        rulesOptions: {
          ...state.rulesOptions,
          standardRules: action.standardRules,
          indexedStandardRules: action.indexedStandardRules,
          xsdRules: action.xsdRules,
          indexedXsdRules: action.indexedXsdRules,
          nationalRules: action.nationalRules,
          indexedNationalRules: action.indexedNationalRules,
          serviceRules: action.serviceRules,
          indexedServiceRules: action.indexedServiceRules,
        },
      }
    case OptionsConstants.SET_STATE_RULES:
      return {
        ...state,
        rulesOptions: {
          ...state.rulesOptions,
          stateRules: action.stateRules,
          indexedStateRules: action.indexedStateRules,
        },
      }
    case OptionsConstants.SET_RULES_UTILS_MODULE:
      return {
        ...state,
        rulesOptions: {
          ...state.rulesOptions,
          rulesUtilsModule: action.rulesUtilsModule,
        },
      }
    case OptionsConstants.SET_SYSTEM_OPTIONS:
      return {
        ...state,
        diagnosisOptions: {
          ...state.diagnosisOptions,
          systemOptions: action.systemOptions,
        },
      }
    case OptionsConstants.SET_SYMPTOMS_OPTIONS:
      return {
        ...state,
        diagnosisOptions: {
          ...state.diagnosisOptions,
          symptomsOptions: action.symptomsOptions,
        },
      }
    case OptionsConstants.SET_IMPRESSIONS_OPTIONS:
      return {
        ...state,
        diagnosisOptions: {
          ...state.diagnosisOptions,
          impressionsOptions: action.impressionsOptions,
        },
      }
    case OptionsConstants.SET_ANATOMIC_LOCATION_OPTIONS:
      return {
        ...state,
        diagnosisOptions: {
          ...state.diagnosisOptions,
          anatomicLocationOptions: action.anatomicLocationOptions,
        },
      }
    case OptionsConstants.SET_CONDITION_AT_DEST_OPTIONS:
      return {
        ...state,
        diagnosisOptions: {
          ...state.diagnosisOptions,
          conditionAtDestinationOptions: action.conditionAtDestinationOptions,
        },
      }
    case OptionsConstants.SET_FINAL_PATIENT_ACUITY_OPTIONS:
      return {
        ...state,
        diagnosisOptions: {
          ...state.diagnosisOptions,
          finalPatientAcuityOptions: action.finalPatientAcuityOptions,
        },
      }
    case OptionsConstants.SET_IS_PATIENT_PREGNANT_OPTIONS:
      return {
        ...state,
        obstetricsOptions: {
          ...state.obstetricsOptions,
          isPatientPregnantOptions: action.isPatientPregnantOptions,
        },
      }

    case OptionsConstants.SET_DYNAMIC_RANGE_OPTIONS: {
      const newState = { ...state }
      set(newState, action?.path || '', action.dynamicRangeOptions)
      return newState
    }

    case OptionsConstants.SET_BLOODY_SHOW_OPTIONS:
      return {
        ...state,
        obstetricsOptions: {
          ...state.obstetricsOptions,
          bloodyShowOptions: action.bloodyShowOptions,
        },
      }

    case OptionsConstants.SET_PRENATAL_CARE_OPTIONS:
      return {
        ...state,
        obstetricsOptions: {
          ...state.obstetricsOptions,
          prenatalCareOptions: action.prenatalCareOptions,
        },
      }

    case OptionsConstants.SET_MEMBRANES_AMNIOTIC_FLUID_OPTIONS:
      return {
        ...state,
        obstetricsOptions: {
          ...state.obstetricsOptions,
          membranesOptions: action.membranesOptions,
        },
      }

    case OptionsConstants.SET_MATERNAL_MEDICATIONS_ADMINISTERED_OPTIONS:
      return {
        ...state,
        obstetricsOptions: {
          ...state.obstetricsOptions,
          maternalMedicationsAdministeredOptions: action.maternalMedicationsAdministeredOptions,
        },
      }
    case OptionsConstants.SET_BURN_TYPE_OPTIONS:
      return {
        ...state,
        burnOptions: {
          ...state.burnOptions,
          burnTypeOptions: action.burnTypeOptions,
        },
      }
    case OptionsConstants.SET_BODY_SURVEY_EXAM_OPTIONS:
      return {
        ...state,
        bodySurveyOptions: {
          ...state.bodySurveyOptions,
          examValueOptions: action.examValueOptions,
        },
      }
    case OptionsConstants.SET_BODY_SURVEY_SELECTED_EXAM_OPTIONS:
      return {
        ...state,
        bodySurveyOptions: {
          ...state.bodySurveyOptions,
          selectedExamOptions: action.selectedExamOptions,
        },
      }
    case OptionsConstants.SET_BODY_SURVEY_BODY_PARTS_OPTIONS:
      return {
        ...state,
        bodySurveyOptions: {
          ...state.bodySurveyOptions,
          bodyPartsOptions: action.bodyPartsOptions,
        },
      }
    case OptionsConstants.SET_BODY_SURVEY_GENERAL_EXTREMITIES_OPTIONS:
      return {
        ...state,
        bodySurveyOptions: {
          ...state.bodySurveyOptions,
          generalExtremitiesOptions: action.generalExtremitiesOptions,
        },
      }
    case OptionsConstants.SET_BODY_SURVEY_SKIN_OPTIONS:
      return {
        ...state,
        bodySurveyOptions: {
          ...state.bodySurveyOptions,
          skinOptions: action.skinOptions,
        },
      }
    case OptionsConstants.SET_BODY_SURVEY_CARDIAC_OPTIONS:
      return {
        ...state,
        bodySurveyOptions: {
          ...state.bodySurveyOptions,
          cardiacExamOptions: action.cardiacExamOptions,
        },
      }
    case OptionsConstants.SET_BODY_SURVEY_MENTAL_OPTIONS:
      return {
        ...state,
        bodySurveyOptions: {
          ...state.bodySurveyOptions,
          mentalExamOptions: action.mentalExamOptions,
        },
      }
    case OptionsConstants.SET_BODY_SURVEY_NEURO_OPTIONS:
      return {
        ...state,
        bodySurveyOptions: {
          ...state.bodySurveyOptions,
          neuroExamOptions: action.neuroExamOptions,
        },
      }
    case OptionsConstants.SET_ASSESSMENT_DEFAULT_OPTIONS:
      return {
        ...state,
        bodySurveyOptions: {
          ...state.bodySurveyOptions,
          assessmentDefaultOptions: action.assessmentDefaultOptions,
        },
      }
    case OptionsConstants.SET_ASSESSMENT_ACTION_OPTIONS:
      return {
        ...state,
        assessmentProcedureOptions: { ...state.assessmentProcedureOptions, actionOptions: action.actionOptions },
      }
    case OptionsConstants.SET_NEURO_GAZE_OPTIONS:
      return {
        ...state,
        assessmentProcedureOptions: { ...state.assessmentProcedureOptions, neuroGazeOptions: action.neuroGazeOptions },
      }
    case OptionsConstants.SET_NEURO_LIMB_OPTIONS:
      return {
        ...state,
        assessmentProcedureOptions: { ...state.assessmentProcedureOptions, neuroLimbOptions: action.neuroLimbOptions },
      }
    case OptionsConstants.SET_NEURO_MOTOR_OPTIONS:
      return {
        ...state,
        assessmentProcedureOptions: {
          ...state.assessmentProcedureOptions,
          neuroMotorOptions: action.neuroMotorOptions,
        },
      }
    case OptionsConstants.SET_NEURO_FACIAL_OPTIONS:
      return {
        ...state,
        assessmentProcedureOptions: {
          ...state.assessmentProcedureOptions,
          neuroFacialOptions: action.neuroFacialOptions,
        },
      }
    case OptionsConstants.SET_NEURO_SPEECH_OPTIONS:
      return {
        ...state,
        assessmentProcedureOptions: {
          ...state.assessmentProcedureOptions,
          neuroSpeechOptions: action.neuroSpeechOptions,
        },
      }
    case OptionsConstants.SET_SEPSIS_INDICATORS_OPTIONS:
      return {
        ...state,
        assessmentProcedureOptions: {
          ...state.assessmentProcedureOptions,
          sepsisIndicatorsOptions: action.sepsisIndicatorsOptions,
        },
      }
    case OptionsConstants.SET_CUSTOM_ACTION_FIELDS_OPTIONS:
      return {
        ...state,
        assessmentProcedureOptions: {
          ...state.assessmentProcedureOptions,
          customActionFieldsOptions: action.customActionFieldsOptions,
        },
      }
    case OptionsConstants.SET_CUSTOM_ACTION_FIELDS_ANSWERS_OPTIONS:
      return {
        ...state,
        assessmentProcedureOptions: {
          ...state.assessmentProcedureOptions,
          customActionFieldsAnswersOptions: action.customActionFieldsAnswersOptions,
        },
      }
    case OptionsConstants.SET_ALL_PNNV_OPTIONS:
      return {
        ...state,
        allPNNVOptions: { ...state.allPNNVOptions, ...action.allPNNVOptions },
      }
    case OptionsConstants.SET_NEMSIS_CUSTOM_OPTIONS:
      return {
        ...state,
        nemsisCustomDataOptions: { ...state.nemsisCustomDataOptions, customDataWithState: action.customDataWithState },
      }
    case OptionsConstants.SET_NEMSIS_CUSTOM_CONFIG_GROUPS:
      return {
        ...state,
        nemsisCustomDataOptions: {
          ...state.nemsisCustomDataOptions,
          customConfigGroupOptions: action.customConfigGroupOptions,
        },
      }
    case OptionsConstants.SET_HIDE_NEMSIS_CUSTOM_OPTION:
      return {
        ...state,
        nemsisCustomDataOptions: {
          ...state.nemsisCustomDataOptions,
          hideNemsisCustomOption: action.hideNemsisCustomOption,
        },
      }
    case OptionsConstants.SET_PT_ID_VERIFIED_OPTIONS:
      return {
        ...state,
        bloodProductAdministrationOptions: {
          ...state.bloodProductAdministrationOptions,
          ptIdVerifiedOptions: action.ptIdVerifiedOptions,
        },
      }
    case OptionsConstants.SET_CLINICAL_INDICATOR_OPTIONS:
      return {
        ...state,
        bloodProductAdministrationOptions: {
          ...state.bloodProductAdministrationOptions,
          clinicalIndicatorOptions: action.clinicalIndicatorOptions,
        },
      }
    case OptionsConstants.SET_CROSS_MATCHED_OPTIONS:
      return {
        ...state,
        bloodProductAdministrationOptions: {
          ...state.bloodProductAdministrationOptions,
          crossMatchedOptions: action.crossMatchedOptions,
        },
      }
    case OptionsConstants.SET_TRANSFUSION_CONSENT_OPTIONS:
      return {
        ...state,
        bloodProductAdministrationOptions: {
          ...state.bloodProductAdministrationOptions,
          transfusionConsentOptions: action.transfusionConsentOptions,
        },
      }
    case OptionsConstants.SET_TRANSFUSION_ORDER_OPTIONS:
      return {
        ...state,
        bloodProductAdministrationOptions: {
          ...state.bloodProductAdministrationOptions,
          transfusionOrderOptions: action.transfusionOrderOptions,
        },
      }
    case OptionsConstants.SET_BLOOD_PRODUCT_OPTIONS:
      return {
        ...state,
        bloodProductAdministrationOptions: {
          ...state.bloodProductAdministrationOptions,
          bloodProductOptions: action.bloodProductOptions,
        },
      }
    case OptionsConstants.SET_BLOOD_PRODUCT_TYPE_OPTIONS:
      return {
        ...state,
        bloodProductAdministrationOptions: {
          ...state.bloodProductAdministrationOptions,
          bloodProductTypeOptions: action.bloodProductTypeOptions,
        },
      }
    case OptionsConstants.SET_BLOOD_PRODUCT_ROUTE_OPTIONS:
      return {
        ...state,
        bloodProductAdministrationOptions: {
          ...state.bloodProductAdministrationOptions,
          bloodProductRouteOptions: action.bloodProductRouteOptions,
        },
      }
    case OptionsConstants.SET_IMPLIED_EMERGENT_CONSENT_REASON_OPTIONS:
      return {
        ...state,
        bloodProductAdministrationOptions: {
          ...state.bloodProductAdministrationOptions,
          impliedEmergentConsentReasonOptions: action.impliedEmergentConsentReasonOptions,
        },
      }
    case OptionsConstants.SET_VAD_TYPE_OPTIONS:
      return {
        ...state,
        ventricularAssistTypeOptions: { ...state.ventricularAssistTypeOptions, vadTypeOptions: action.vadTypeOptions },
      }
    case OptionsConstants.SET_VAD_ALARMS_OPTIONS:
      return {
        ...state,
        ventricularAssistTypeOptions: {
          ...state.ventricularAssistTypeOptions,
          vadAlarmsOptions: action.vadAlarmsOptions,
        },
      }
    case OptionsConstants.SET_VAD_SITE_ASSESSMENT_OPTIONS:
      return {
        ...state,
        ventricularAssistTypeOptions: {
          ...state.ventricularAssistTypeOptions,
          vadSiteAssessmentOptions: action.vadSiteAssessmentOptions,
        },
      }
    case OptionsConstants.SET_VAD_CATHETER_SIZE_OPTIONS:
      return {
        ...state,
        ventricularAssistTypeOptions: {
          ...state.ventricularAssistTypeOptions,
          vadCatheterSizeOptions: action.vadCatheterSizeOptions,
        },
      }
    case OptionsConstants.SET_VAD_PLACEMENT_CONFIRMED_BY_OPTIONS:
      return {
        ...state,
        ventricularAssistTypeOptions: {
          ...state.ventricularAssistTypeOptions,
          vadPlacementConfirmedByOptions: action.vadPlacementConfirmedByOptions,
        },
      }
    case OptionsConstants.SET_VAD_INSERT_LOCATION_OPTIONS:
      return {
        ...state,
        ventricularAssistTypeOptions: {
          ...state.ventricularAssistTypeOptions,
          vadInsertLocationOptions: action.vadInsertLocationOptions,
        },
      }
    case OptionsConstants.SET_VAD_MOTOR_CURRENT_WAVEFORM_CHARACTERISTICS_OPTIONS:
      return {
        ...state,
        ventricularAssistTypeOptions: {
          ...state.ventricularAssistTypeOptions,
          vadMotorCurrentWaveformCharacteristicsOptions: action.vadMotorCurrentWaveformCharacteristicsOptions,
        },
      }
    case OptionsConstants.SET_VAD_PLACEMENT_SIGNAL_WAVE_FORM_CHARACTERISTICS_OPTIONS:
      return {
        ...state,
        ventricularAssistTypeOptions: {
          ...state.ventricularAssistTypeOptions,
          vadPlacementSignalWaveformCharacteristicsOptions: action.vadPlacementSignalWaveformCharacteristicsOptions,
        },
      }
    case OptionsConstants.SET_VAD_PLACEMENT_LOCATION_OPTIONS:
      return {
        ...state,
        ventricularAssistTypeOptions: {
          ...state.ventricularAssistTypeOptions,
          vadPlacementLocationOptions: action.vadPlacementLocationOptions,
        },
      }
    case OptionsConstants.SET_VAD_POWER_TYPE_OPTIONS:
      return {
        ...state,
        ventricularAssistTypeOptions: {
          ...state.ventricularAssistTypeOptions,
          vadPowerTypeOptions: action.vadPowerTypeOptions,
        },
      }
    case OptionsConstants.SET_VAD_BACKUP_OPTIONS_OPTIONS:
      return {
        ...state,
        ventricularAssistTypeOptions: {
          ...state.ventricularAssistTypeOptions,
          vadBackupOptions: action.vadBackupOptions,
        },
      }
    case OptionsConstants.SET_VAD_BATTERY_STATUS_OPTIONS:
      return {
        ...state,
        ventricularAssistTypeOptions: {
          ...state.ventricularAssistTypeOptions,
          vadBatteryStatusOptions: action.vadBatteryStatusOptions,
        },
      }
    case OptionsConstants.SET_VAD_FLOW_TYPE_OPTIONS:
      return {
        ...state,
        ventricularAssistTypeOptions: {
          ...state.ventricularAssistTypeOptions,
          vadFlowTypeOptions: action.vadFlowTypeOptions,
        },
      }
    case OptionsConstants.SET_VAD_INDICATION_OPTIONS:
      return {
        ...state,
        ventricularAssistTypeOptions: {
          ...state.ventricularAssistTypeOptions,
          vadIndicationOptions: action.vadIndicationOptions,
        },
      }
    case OptionsConstants.SET_VAD_MAKE_MODEL_OPTIONS:
      return {
        ...state,
        ventricularAssistTypeOptions: {
          ...state.ventricularAssistTypeOptions,
          vadMakeModelOptions: action.vadMakeModelOptions,
        },
      }
    case OptionsConstants.SET_VAD_MAKE_MODEL_IMPELLA_OPTIONS:
      return {
        ...state,
        ventricularAssistTypeOptions: {
          ...state.ventricularAssistTypeOptions,
          vadMakeModelImpellaOptions: action.vadMakeModelImpellaOptions,
        },
      }
    case OptionsConstants.SET_YES_NO_OPTIONS:
      return {
        ...state,
        genericOptions: {
          ...state.genericOptions,
          yesNoOptions: action.yesNoOptions,
        },
      }
    case OptionsConstants.SET_CRITICAL_CARE_SITE_OPTIONS_DOC:
      return {
        ...state,
        criticalCareOptions: {
          ...state.criticalCareOptions,
          siteOptions: action.siteOptions,
        },
      }
    case OptionsConstants.SET_IABP_AUGMENTATION_OPTIONS_DOC:
      return {
        ...state,
        criticalCareOptions: {
          ...state.criticalCareOptions,
          iabpAugmentationOptions: action.iabpAugmentationOptions,
        },
      }
    case OptionsConstants.SET_TASK_OPTIONS_DOC:
      return {
        ...state,
        criticalCareOptions: {
          ...state.criticalCareOptions,
          taskOptions: action.taskOptions,
        },
      }
    case OptionsConstants.SET_IABP_FREQUENCY_OPTIONS_DOC:
      return {
        ...state,
        criticalCareOptions: {
          ...state.criticalCareOptions,
          iabpFrequencyOptions: action.iabpFrequencyOptions,
        },
      }
    case OptionsConstants.SET_INSERTION_SITE_OPTIONS_DOC:
      return {
        ...state,
        criticalCareOptions: {
          ...state.criticalCareOptions,
          insertionSiteOptions: action.insertionSiteOptions,
        },
      }
    case OptionsConstants.SET_TRIGGER_UTILIZED_OPTIONS_DOC:
      return {
        ...state,
        criticalCareOptions: {
          ...state.criticalCareOptions,
          triggerUtilizedOptions: action.triggerUtilizedOptions,
        },
      }
    case OptionsConstants.SET_CRITICAL_CARE_ACTION_OPTIONS_DOC:
      return {
        ...state,
        criticalCareOptions: {
          ...state.criticalCareOptions,
          actionOptions: action.actionOptions,
        },
      }
    case OptionsConstants.SET_SLOW_GAS_LEAK_OPTIONS_DOC:
      return {
        ...state,
        criticalCareOptions: {
          ...state.criticalCareOptions,
          slowGasLeakOptions: action.slowGasLeakOptions,
        },
      }
    case OptionsConstants.SET_AUTO_MANUAL_OPTIONS_DOC:
      return {
        ...state,
        criticalCareOptions: {
          ...state.criticalCareOptions,
          autoManualOptions: action.autoManualOptions,
        },
      }
    case OptionsConstants.SET_SCT_PROCS_OPTIONS:
      return {
        ...state,
        sctOptions: {
          ...state.sctOptions,
          sctProcsOptions: action.sctProcsOptions,
        },
      }
    case OptionsConstants.SET_SCT_MEDS_OPTIONS:
      return {
        ...state,
        sctOptions: {
          ...state.sctOptions,
          sctMedsOptions: action.sctMedsOptions,
        },
      }
    case OptionsConstants.SET_CUSTOM_FLUIDS_OPTIONS:
      return {
        ...state,
        customFluidsOptions: action.customFluidsOptions,
      }
    case OptionsConstants.SET_APGAR_APPEARANCE_OPTIONS:
      return {
        ...state,
        vitalOptions: {
          ...state.vitalOptions,
          apgarAppearanceOptions: action.apgarAppearanceOptions,
        },
      }
    case OptionsConstants.SET_APGAR_PULSE_OPTIONS:
      return {
        ...state,
        vitalOptions: {
          ...state.vitalOptions,
          apgarPulseOptions: action.apgarPulseOptions,
        },
      }
    case OptionsConstants.SET_APGAR_GRIMACE_OPTIONS:
      return {
        ...state,
        vitalOptions: {
          ...state.vitalOptions,
          apgarGrimaceOptions: action.apgarGrimaceOptions,
        },
      }
    case OptionsConstants.SET_APGAR_ACTIVITY_OPTIONS:
      return {
        ...state,
        vitalOptions: {
          ...state.vitalOptions,
          apgarActivityOptions: action.apgarActivityOptions,
        },
      }
    case OptionsConstants.SET_APGAR_RESPIRATION_OPTIONS:
      return {
        ...state,
        vitalOptions: {
          ...state.vitalOptions,
          apgarRespirationOptions: action.apgarRespirationOptions,
        },
      }
    case OptionsConstants.SET_TEAM_OPTIONS:
      return {
        ...state,
        tripInformationOptions: {
          ...state.tripInformationOptions,
          teamOptions: action.teamOptions,
        },
      }
    case OptionsConstants.SET_TEAM_CARE_ONLY_OPTIONS:
      return {
        ...state,
        tripInformationOptions: {
          ...state.tripInformationOptions,
          teamCareOnlyOptions: action.teamCareOnlyOptions,
        },
      }
    case OptionsConstants.SET_EQUIPMENT_OPTIONS:
      return {
        ...state,
        tripInformationOptions: {
          ...state.tripInformationOptions,
          equipmentOptions: action.equipmentOptions,
        },
      }
    case OptionsConstants.SET_PROVIDER_ROLES_OPTIONS:
      return {
        ...state,
        tripInformationOptions: {
          ...state.tripInformationOptions,
          providerRolesOptions: action.providerRolesOptions,
        },
      }
    case OptionsConstants.SET_FLIGHT_PLAN_OPTIONS:
      return {
        ...state,
        tripInformationOptions: {
          ...state.tripInformationOptions,
          flightPlanOptions: action.flightPlanOptions,
        },
      }
    case OptionsConstants.SET_ADMINISTERED_BY_OTHER_UNIT_OPTIONS:
      return {
        ...state,
        addMedicationAdministeredOptions: {
          ...state.addMedicationAdministeredOptions,
          administeredByAnotherUnitOptions: action.administeredByAnotherUnitOptions,
        },
      }
    case OptionsConstants.SET_SPECIAL_REPORT_DATA:
      return {
        ...state,
        specialReportOptions: {
          ...state.specialReportOptions,
          specialReportData: action.specialReportData,
        },
      }
    case OptionsConstants.SET_SPECIAL_REPORT_CATEGORIES:
      return {
        ...state,
        specialReportOptions: {
          ...state.specialReportOptions,
          categories: action.categories,
        },
      }
    case OptionsConstants.SET_SPECIAL_REPORT_SUB_CATEGORIES:
      return {
        ...state,
        specialReportOptions: {
          ...state.specialReportOptions,
          subCategories: action.subCategories,
        },
      }
    case OptionsConstants.SET_FILLABLE_PDF_METADATA:
      return {
        ...state,
        fillablePDFOptions: {
          ...state.fillablePDFOptions,
          metadata: action.metadata,
        },
      }
    case OptionsConstants.SET_FILLABLE_PDF_BINDINGS:
      return {
        ...state,
        fillablePDFOptions: {
          ...state.fillablePDFOptions,
          bindings: action.bindings,
        },
      }
    case OptionsConstants.SET_PULSARA_DATE_RANGE_OPTIONS:
      return {
        ...state,
        pulsaraOptions: {
          ...state.pulsaraOptions,
          pulsaraDateRangeOptions: action.pulsaraDateRangeOptions,
        },
      }
    default:
      return state
  }
}
